/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as RegistrationRouteImport } from './routes/registration.route'
import { Route as EventsRouteImport } from './routes/events/route'
import { Route as PrivateRouteImport } from './routes/_private/route'
import { Route as LayoutAuthRouteImport } from './routes/_layoutAuth/route'
import { Route as PrivateIndexRouteImport } from './routes/_private/index.route'
import { Route as EventsRsvpRouteImport } from './routes/events/rsvp.route'
import { Route as PrivateRouteRouteImport } from './routes/_private/_route/route'
import { Route as LayoutAuthGuestRouteImport } from './routes/_layoutAuth/_guest/route'
import { Route as PrivateTeamsIndexRouteImport } from './routes/_private/teams/index.route'
import { Route as LayoutAuthUnsupportedAccountIndexRouteImport } from './routes/_layoutAuth/unsupported-account/index.route'
import { Route as LayoutAuthMaintenanceIndexRouteImport } from './routes/_layoutAuth/maintenance/index.route'
import { Route as LayoutAuthLogoutIndexRouteImport } from './routes/_layoutAuth/logout/index.route'
import { Route as LayoutAuthExecAccessDisabledIndexRouteImport } from './routes/_layoutAuth/exec-access-disabled/index.route'
import { Route as PrivateRouteProfileRouteImport } from './routes/_private/_route/profile/route'
import { Route as PrivateRouteInternalRouteImport } from './routes/_private/_route/_internal/route'
import { Route as PrivateRouteSplatRouteImport } from './routes/_private/_route/$.route'
import { Route as PrivateAuthSetPasswordRouteImport } from './routes/_private/_auth/set-password.route'
import { Route as PrivateTeamsTeamIdIndexRouteImport } from './routes/_private/teams/$teamId.index.route'
import { Route as PrivateRouteUsersIndexRouteImport } from './routes/_private/_route/users/index.route'
import { Route as PrivateRouteProfileIndexRouteImport } from './routes/_private/_route/profile/index.route'
import { Route as PrivateAuthSignupIndexRouteImport } from './routes/_private/_auth/signup/index.route'
import { Route as LayoutAuthGuestLoginIndexRouteImport } from './routes/_layoutAuth/_guest/login/index.route'
import { Route as LayoutAuthGuestJoinIndexRouteImport } from './routes/_layoutAuth/_guest/join/index.route'
import { Route as LayoutAuthGuestEmailResponseIndexRouteImport } from './routes/_layoutAuth/_guest/email-response/index.route'
import { Route as PrivateRouteUsersUserIdRouteImport } from './routes/_private/_route/users/$userId/route'
import { Route as PrivateRouteTeamsTeamIdRouteImport } from './routes/_private/_route/teams/$teamId/route'
import { Route as PrivateRouteInternalTrendingRouteImport } from './routes/_private/_route/_internal/trending/route'
import { Route as PrivateRouteInternalTasksRouteImport } from './routes/_private/_route/_internal/tasks/route'
import { Route as PrivateRouteInternalPipelinesRouteImport } from './routes/_private/_route/_internal/pipelines/route'
import { Route as PrivateRouteInternalEventsRouteImport } from './routes/_private/_route/_internal/events/route'
import { Route as PrivateRouteInternalAdminRouteImport } from './routes/_private/_route/_internal/admin/route'
import { Route as PrivateRouteUsersNewIndexRouteImport } from './routes/_private/_route/users/new/index.route'
import { Route as PrivateRouteUsersUserIdIndexRouteImport } from './routes/_private/_route/users/$userId/index.route'
import { Route as PrivateRouteProfileTeamsIndexRouteImport } from './routes/_private/_route/profile/teams/index.route'
import { Route as PrivateRouteInternalTrendingIndexRouteImport } from './routes/_private/_route/_internal/trending/index.route'
import { Route as PrivateRouteInternalToolsIndexRouteImport } from './routes/_private/_route/_internal/tools/index.route'
import { Route as PrivateRouteInternalTasksIndexRouteImport } from './routes/_private/_route/_internal/tasks/index.route'
import { Route as PrivateRouteInternalSearchesIndexRouteImport } from './routes/_private/_route/_internal/searches/index.route'
import { Route as PrivateRouteInternalSearchSubmissionsIndexRouteImport } from './routes/_private/_route/_internal/search-submissions/index.route'
import { Route as PrivateRouteInternalPipelineSubmissionsIndexRouteImport } from './routes/_private/_route/_internal/pipeline-submissions/index.route'
import { Route as PrivateRouteInternalPerformanceIndexRouteImport } from './routes/_private/_route/_internal/performance/index.route'
import { Route as PrivateRouteInternalPeopleIndexRouteImport } from './routes/_private/_route/_internal/people/index.route'
import { Route as PrivateRouteInternalPeersIndexRouteImport } from './routes/_private/_route/_internal/peers/index.route'
import { Route as PrivateRouteInternalIntroductionsIndexRouteImport } from './routes/_private/_route/_internal/introductions/index.route'
import { Route as PrivateRouteInternalHomeIndexRouteImport } from './routes/_private/_route/_internal/home/index.route'
import { Route as PrivateRouteInternalExperimentsIndexRouteImport } from './routes/_private/_route/_internal/experiments/index.route'
import { Route as PrivateRouteInternalEventsIndexRouteImport } from './routes/_private/_route/_internal/events/index.route'
import { Route as PrivateRouteInternalCompaniesIndexRouteImport } from './routes/_private/_route/_internal/companies/index.route'
import { Route as PrivateRouteUsersUserIdTrendingRouteImport } from './routes/_private/_route/users/$userId/trending/route'
import { Route as PrivateRouteUsersUserIdPeopleRouteImport } from './routes/_private/_route/users/$userId/people/route'
import { Route as PrivateRouteTeamsTeamIdNetworkRouteImport } from './routes/_private/_route/teams/$teamId/network/route'
import { Route as PrivateRouteTeamsTeamIdCandidatesRouteImport } from './routes/_private/_route/teams/$teamId/candidates/route'
import { Route as PrivateRouteInternalPipelinesNewRouteImport } from './routes/_private/_route/_internal/pipelines_/new/route'
import { Route as PrivateRouteInternalPeopleIdentityIdRouteImport } from './routes/_private/_route/_internal/people/$identityId/route'
import { Route as PrivateRouteInternalEventsEventIdRouteImport } from './routes/_private/_route/_internal/events/$eventId/route'
import { Route as PrivateRouteInternalCandidatesCandidateIdRouteImport } from './routes/_private/_route/_internal/candidates/$candidateId/route'
import { Route as PrivateRouteInternalPipelinesIndexRouteImport } from './routes/_private/_route/_internal/pipelines/index/route'
import { Route as PrivateRouteUsersUserIdTrendingIndexImport } from './routes/_private/_route/users/$userId/trending/index'
import { Route as PrivateRouteTeamsTeamIdTrendingIndexImport } from './routes/_private/_route/teams/$teamId/trending/index'
import { Route as PrivateRouteUsersUserIdSettingsIndexRouteImport } from './routes/_private/_route/users/$userId/settings/index.route'
import { Route as PrivateRouteUsersUserIdPipelinesIndexRouteImport } from './routes/_private/_route/users/$userId/pipelines/index.route'
import { Route as PrivateRouteUsersUserIdEventsIndexRouteImport } from './routes/_private/_route/users/$userId/events/index.route'
import { Route as PrivateRouteTeamsTeamIdSettingsIndexRouteImport } from './routes/_private/_route/teams/$teamId/settings/index.route'
import { Route as PrivateRouteTeamsTeamIdSearchesIndexRouteImport } from './routes/_private/_route/teams/$teamId/searches/index.route'
import { Route as PrivateRouteTeamsTeamIdPipelinesIndexRouteImport } from './routes/_private/_route/teams/$teamId/pipelines/index.route'
import { Route as PrivateRouteTeamsTeamIdIntroductionsIndexRouteImport } from './routes/_private/_route/teams/$teamId/introductions/index.route'
import { Route as PrivateRouteTeamsTeamIdHomeIndexRouteImport } from './routes/_private/_route/teams/$teamId/home/index.route'
import { Route as PrivateRouteInternalTrendingPeopleIndexRouteImport } from './routes/_private/_route/_internal/trending/people/index.route'
import { Route as PrivateRouteInternalTrendingNewIndexRouteImport } from './routes/_private/_route/_internal/trending/new/index.route'
import { Route as PrivateRouteInternalTrendingCampaignsIndexRouteImport } from './routes/_private/_route/_internal/trending/campaigns/index.route'
import { Route as PrivateRouteInternalTrendingSubmissionIdIndexRouteImport } from './routes/_private/_route/_internal/trending/$submissionId/index.route'
import { Route as PrivateRouteInternalToolsPathwayActivityDefaultsIndexRouteImport } from './routes/_private/_route/_internal/tools/pathway-activity-defaults/index.route'
import { Route as PrivateRouteInternalToolsMoveTeamIndexRouteImport } from './routes/_private/_route/_internal/tools/move-team/index.route'
import { Route as PrivateRouteInternalToolsMergePeopleIndexRouteImport } from './routes/_private/_route/_internal/tools/merge-people/index.route'
import { Route as PrivateRouteInternalToolsMarketSearchesIndexRouteImport } from './routes/_private/_route/_internal/tools/market-searches/index.route'
import { Route as PrivateRouteInternalToolsEmailTemplatesIndexRouteImport } from './routes/_private/_route/_internal/tools/email-templates/index.route'
import { Route as PrivateRouteInternalToolsAiCandidateDiscoveryIndexRouteImport } from './routes/_private/_route/_internal/tools/ai-candidate-discovery/index.route'
import { Route as PrivateRouteInternalTasksMeIndexRouteImport } from './routes/_private/_route/_internal/tasks/me/index.route'
import { Route as PrivateRouteInternalTasksExecutiveServicesIndexRouteImport } from './routes/_private/_route/_internal/tasks/executive-services/index.route'
import { Route as PrivateRouteInternalPipelineSubmissionsSubmissionIdIndexRouteImport } from './routes/_private/_route/_internal/pipeline-submissions/$submissionId/index.route'
import { Route as PrivateRouteInternalPeopleIdentityIdIndexRouteImport } from './routes/_private/_route/_internal/people/$identityId/index.route'
import { Route as PrivateRouteInternalPeersNewIndexRouteImport } from './routes/_private/_route/_internal/peers/new/index.route'
import { Route as PrivateRouteInternalIntroductionSubmissionsSubmissionIdIndexRouteImport } from './routes/_private/_route/_internal/introduction-submissions/$submissionId/index.route'
import { Route as PrivateRouteInternalEventsSettingsIndexRouteImport } from './routes/_private/_route/_internal/events/settings/index.route'
import { Route as PrivateRouteInternalEventsParticipantsIndexRouteImport } from './routes/_private/_route/_internal/events/participants/index.route'
import { Route as PrivateRouteInternalEventsNewIndexRouteImport } from './routes/_private/_route/_internal/events/new/index.route'
import { Route as PrivateRouteInternalEventsEventsIndexRouteImport } from './routes/_private/_route/_internal/events/events/index.route'
import { Route as PrivateRouteInternalEventsEventIdIndexRouteImport } from './routes/_private/_route/_internal/events/$eventId/index.route'
import { Route as PrivateRouteInternalCandidatesNewIndexRouteImport } from './routes/_private/_route/_internal/candidates/new/index.route'
import { Route as PrivateRouteInternalCandidatesCandidateIdIndexRouteImport } from './routes/_private/_route/_internal/candidates/$candidateId/index.route'
import { Route as PrivateRouteInternalAdminUsersIndexRouteImport } from './routes/_private/_route/_internal/admin/users/index.route'
import { Route as PrivateRouteUsersUserIdPipelinesNewRouteImport } from './routes/_private/_route/users/$userId/pipelines/new.route'
import { Route as PrivateRouteUsersUserIdPeopleCandidateIdRouteImport } from './routes/_private/_route/users/$userId/people/$candidateId/route'
import { Route as PrivateRouteTeamsTeamIdPipelinesNewRouteImport } from './routes/_private/_route/teams/$teamId/pipelines/new.route'
import { Route as PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteImport } from './routes/_private/_route/teams/$teamId/candidates/$candidateId/route'
import { Route as PrivateRouteInternalPeopleIdentityIdCandidateRouteImport } from './routes/_private/_route/_internal/people/$identityId/_candidate/route'
import { Route as PrivateRouteInternalEventsParticipantsParticipantIdRouteImport } from './routes/_private/_route/_internal/events/participants/$participantId/route'
import { Route as PrivateRouteInternalEventsEventIdParticipantsRouteImport } from './routes/_private/_route/_internal/events/$eventId/participants/route'
import { Route as PrivateRouteInternalCandidatesCandidateIdTasksRouteImport } from './routes/_private/_route/_internal/candidates/$candidateId/tasks/route'
import { Route as PrivateRouteInternalAdminUsersUserIdRouteImport } from './routes/_private/_route/_internal/admin/users/$userId/route'
import { Route as PrivateRouteUsersUserIdTrendingRecommendationIdIndexRouteImport } from './routes/_private/_route/users/$userId/trending/$recommendationId/index.route'
import { Route as PrivateRouteUsersUserIdPipelinesPipelineIdIndexRouteImport } from './routes/_private/_route/users/$userId/pipelines/$pipelineId/index.route'
import { Route as PrivateRouteUsersUserIdEventsEventIdIndexRouteImport } from './routes/_private/_route/users/$userId/events/$eventId/index.route'
import { Route as PrivateRouteTeamsTeamIdTrendingRecommendationIdIndexRouteImport } from './routes/_private/_route/teams/$teamId/trending/$recommendationId/index.route'
import { Route as PrivateRouteTeamsTeamIdSearchesSearchIdIndexRouteImport } from './routes/_private/_route/teams/$teamId/searches/$searchId/index.route'
import { Route as PrivateRouteTeamsTeamIdIntroductionsCandidateIdIndexRouteImport } from './routes/_private/_route/teams/$teamId/introductions/$candidateId/index.route'
import { Route as PrivateRouteTeamsTeamIdCandidatesCandidateIdIndexRouteImport } from './routes/_private/_route/teams/$teamId/candidates/$candidateId/index.route'
import { Route as PrivateRouteInternalTrendingSubmissionIdEditIndexRouteImport } from './routes/_private/_route/_internal/trending/$submissionId/edit/index.route'
import { Route as PrivateRouteInternalPeopleIdentityIdEmailsIndexRouteImport } from './routes/_private/_route/_internal/people/$identityId/emails/index.route'
import { Route as PrivateRouteInternalPeopleIdentityIdAccountsIndexRouteImport } from './routes/_private/_route/_internal/people/$identityId/accounts/index.route'
import { Route as PrivateRouteInternalEventsParticipantsParticipantIdIndexRouteImport } from './routes/_private/_route/_internal/events/participants/$participantId/index.route'
import { Route as PrivateRouteInternalEventsEventIdEmailsIndexRouteImport } from './routes/_private/_route/_internal/events/$eventId/emails/index.route'
import { Route as PrivateRouteInternalEventsEventIdEmailSettingsIndexRouteImport } from './routes/_private/_route/_internal/events/$eventId/email-settings/index.route'
import { Route as PrivateRouteInternalEventsEventIdDetailsIndexRouteImport } from './routes/_private/_route/_internal/events/$eventId/details/index.route'
import { Route as PrivateRouteInternalCompaniesCompanyIdSettingsIndexRouteImport } from './routes/_private/_route/_internal/companies/$companyId/settings/index.route'
import { Route as PrivateRouteInternalCompaniesCompanyIdPeopleIndexRouteImport } from './routes/_private/_route/_internal/companies/$companyId/people/index.route'
import { Route as PrivateRouteInternalCandidatesCandidateIdSuggestedPipelinesIndexRouteImport } from './routes/_private/_route/_internal/candidates/$candidateId/suggested-pipelines/index.route'
import { Route as PrivateRouteInternalCandidatesCandidateIdRecommendationsIndexRouteImport } from './routes/_private/_route/_internal/candidates/$candidateId/recommendations.index.route'
import { Route as PrivateRouteInternalCandidatesCandidateIdProfileIndexRouteImport } from './routes/_private/_route/_internal/candidates/$candidateId/profile/index.route'
import { Route as PrivateRouteInternalCandidatesCandidateIdPerformanceIndexRouteImport } from './routes/_private/_route/_internal/candidates/$candidateId/performance/index.route'
import { Route as PrivateRouteInternalCandidatesCandidateIdFeedbackIndexRouteImport } from './routes/_private/_route/_internal/candidates/$candidateId/feedback/index.route'
import { Route as PrivateRouteInternalCandidatesCandidateIdCompareIndexRouteImport } from './routes/_private/_route/_internal/candidates/$candidateId/compare/index.route'
import { Route as PrivateRouteInternalCandidatesCandidateIdAccountsIndexRouteImport } from './routes/_private/_route/_internal/candidates/$candidateId/accounts/index.route'
import { Route as PrivateRouteInternalCandidatesCandidateIdAboutIndexRouteImport } from './routes/_private/_route/_internal/candidates/$candidateId/about/index.route'
import { Route as PrivateRouteInternalAdminUsersNewIndexRouteImport } from './routes/_private/_route/_internal/admin/users/new/index.route'
import { Route as PrivateRouteUsersUserIdPipelinesPipelineIdEditRouteImport } from './routes/_private/_route/users/$userId/pipelines/$pipelineId/edit.route'
import { Route as PrivateRouteTeamsTeamIdPipelinesPipelineIdEditRouteImport } from './routes/_private/_route/teams/$teamId/pipelines_/$pipelineId/edit.route'
import { Route as PrivateRouteTeamsTeamIdCandidatesCandidateIdTabIdRouteImport } from './routes/_private/_route/teams/$teamId/candidates/$candidateId/$tabId.route'
import { Route as PrivateRouteInternalPeopleIdentityIdCandidateTasksRouteImport } from './routes/_private/_route/_internal/people/$identityId/_candidate/tasks/route'
import { Route as PrivateRouteTeamsTeamIdCandidatesCandidateIdPipelinesIndexRouteImport } from './routes/_private/_route/teams/$teamId/candidates/$candidateId/pipelines/index.route'
import { Route as PrivateRouteTeamsTeamIdCandidatesCandidateIdActivityIndexRouteImport } from './routes/_private/_route/teams/$teamId/candidates/$candidateId/activity/index.route'
import { Route as PrivateRouteInternalPeopleIdentityIdCandidateSuggestedPipelinesIndexRouteImport } from './routes/_private/_route/_internal/people/$identityId/_candidate/suggested-pipelines/index.route'
import { Route as PrivateRouteInternalPeopleIdentityIdCandidateRecommendationsIndexRouteImport } from './routes/_private/_route/_internal/people/$identityId/_candidate/recommendations.index.route'
import { Route as PrivateRouteInternalPeopleIdentityIdCandidateProfileIndexRouteImport } from './routes/_private/_route/_internal/people/$identityId/_candidate/profile/index.route'
import { Route as PrivateRouteInternalPeopleIdentityIdCandidatePerformanceIndexRouteImport } from './routes/_private/_route/_internal/people/$identityId/_candidate/performance/index.route'
import { Route as PrivateRouteInternalPeopleIdentityIdCandidateFeedbackIndexRouteImport } from './routes/_private/_route/_internal/people/$identityId/_candidate/feedback/index.route'
import { Route as PrivateRouteInternalPeopleIdentityIdCandidateCompareIndexRouteImport } from './routes/_private/_route/_internal/people/$identityId/_candidate/compare/index.route'
import { Route as PrivateRouteInternalPeopleIdentityIdCandidateAboutIndexRouteImport } from './routes/_private/_route/_internal/people/$identityId/_candidate/about/index.route'
import { Route as PrivateRouteInternalEventsEventIdParticipantsNewIndexRouteImport } from './routes/_private/_route/_internal/events/$eventId/participants/new/index.route'
import { Route as PrivateRouteInternalAdminUsersUserIdSettingsIndexRouteImport } from './routes/_private/_route/_internal/admin/users/$userId/settings/index.route'
import { Route as PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsNewRouteImport } from './routes/_private/_route/users/$userId/pipelines/$pipelineId_/recommendations/new/route'
import { Route as PrivateRouteTeamsTeamIdPipelinesPipelineIdRecommendationsNewRouteImport } from './routes/_private/_route/teams/$teamId/pipelines/$pipelineId_/recommendations/new/route'
import { Route as PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRouteImport } from './routes/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations/route'
import { Route as PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalIndexRouteImport } from './routes/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/index/route'
import { Route as PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsRecommendationIdIndexRouteImport } from './routes/_private/_route/users/$userId/pipelines/$pipelineId/recommendations.$recommendationId.index.route'
import { Route as PrivateRouteTeamsTeamIdSearchesSearchIdCandidatesCandidateIdIndexRouteImport } from './routes/_private/_route/teams/$teamId/searches/$searchId/candidates/$candidateId/index.route'
import { Route as PrivateRouteTeamsTeamIdPipelinesPipelineIdSubmissionsSubmissionIdIndexRouteImport } from './routes/_private/_route/teams/$teamId/pipelines/$pipelineId_/submissions.$submissionId.index.route'
import { Route as PrivateRouteTeamsTeamIdPipelinesPipelineIdIntroductionsCandidateIdIndexRouteImport } from './routes/_private/_route/teams/$teamId/pipelines/$pipelineId/introductions.$candidateId.index.route'
import { Route as PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsIndexRouteImport } from './routes/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations/index.route'
import { Route as PrivateRouteInternalCandidatesCandidateIdTasksGoalsGoalIdIndexRouteImport } from './routes/_private/_route/_internal/candidates/$candidateId/tasks/goals/$goalId/index.route'
import { Route as PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRecommendationIdIndexRouteImport } from './routes/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations/$recommendationId/index.route'
import { Route as PrivateRouteInternalTeamsTeamIdSearchesSearchIdSubmissionsSubmissionIdIndexRouteImport } from './routes/_private/_route/_internal/teams/$teamId/searches/$searchId/submissions/$submissionId/index.route'
import { Route as PrivateRouteInternalPeopleIdentityIdCandidateTasksGoalsGoalIdIndexRouteImport } from './routes/_private/_route/_internal/people/$identityId/_candidate/tasks/goals/$goalId/index.route'

// Create Virtual Routes

const PrivateAuthLazyImport = createFileRoute('/_private/_auth')()
const PrivateRouteTeamsTeamIdTrendingLazyImport = createFileRoute(
  '/_private/_route/teams/$teamId/trending',
)()
const PrivateRouteTeamsTeamIdPipelinesPipelineIdLazyImport = createFileRoute(
  '/_private/_route/teams/$teamId/pipelines/$pipelineId',
)()
const PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalLazyImport =
  createFileRoute(
    '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal',
  )()
const PrivateRouteInternalPeopleIdentityIdCandidateTasksIndexLazyImport =
  createFileRoute(
    '/_private/_route/_internal/people/$identityId/_candidate/tasks/',
  )()

// Create/Update Routes

const RegistrationRouteRoute = RegistrationRouteImport.update({
  path: '/registration',
  getParentRoute: () => rootRoute,
} as any)

const EventsRouteRoute = EventsRouteImport.update({
  path: '/events',
  getParentRoute: () => rootRoute,
} as any)

const PrivateRouteRoute = PrivateRouteImport.update({
  id: '/_private',
  getParentRoute: () => rootRoute,
} as any)

const LayoutAuthRouteRoute = LayoutAuthRouteImport.update({
  id: '/_layoutAuth',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/_layoutAuth/lazy').then((d) => d.Route))

const PrivateIndexRouteRoute = PrivateIndexRouteImport.update({
  path: '/',
  getParentRoute: () => PrivateRouteRoute,
} as any)

const PrivateAuthLazyRoute = PrivateAuthLazyImport.update({
  id: '/_auth',
  getParentRoute: () => PrivateRouteRoute,
} as any).lazy(() =>
  import('./routes/_private/_auth/lazy').then((d) => d.Route),
)

const EventsRsvpRouteRoute = EventsRsvpRouteImport.update({
  path: '/rsvp',
  getParentRoute: () => EventsRouteRoute,
} as any).lazy(() => import('./routes/events/rsvp.lazy').then((d) => d.Route))

const PrivateRouteRouteRoute = PrivateRouteRouteImport.update({
  id: '/_route',
  getParentRoute: () => PrivateRouteRoute,
} as any).lazy(() =>
  import('./routes/_private/_route/lazy').then((d) => d.Route),
)

const LayoutAuthGuestRouteRoute = LayoutAuthGuestRouteImport.update({
  id: '/_guest',
  getParentRoute: () => LayoutAuthRouteRoute,
} as any)

const PrivateTeamsIndexRouteRoute = PrivateTeamsIndexRouteImport.update({
  path: '/teams/',
  getParentRoute: () => PrivateRouteRoute,
} as any)

const LayoutAuthUnsupportedAccountIndexRouteRoute =
  LayoutAuthUnsupportedAccountIndexRouteImport.update({
    path: '/unsupported-account/',
    getParentRoute: () => LayoutAuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layoutAuth/unsupported-account/index.lazy').then(
      (d) => d.Route,
    ),
  )

const LayoutAuthMaintenanceIndexRouteRoute =
  LayoutAuthMaintenanceIndexRouteImport.update({
    path: '/maintenance/',
    getParentRoute: () => LayoutAuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layoutAuth/maintenance/index.lazy').then((d) => d.Route),
  )

const LayoutAuthLogoutIndexRouteRoute = LayoutAuthLogoutIndexRouteImport.update(
  {
    path: '/logout/',
    getParentRoute: () => LayoutAuthRouteRoute,
  } as any,
).lazy(() =>
  import('./routes/_layoutAuth/logout/index.lazy').then((d) => d.Route),
)

const LayoutAuthExecAccessDisabledIndexRouteRoute =
  LayoutAuthExecAccessDisabledIndexRouteImport.update({
    path: '/exec-access-disabled/',
    getParentRoute: () => LayoutAuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layoutAuth/exec-access-disabled/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteProfileRouteRoute = PrivateRouteProfileRouteImport.update({
  path: '/profile',
  getParentRoute: () => PrivateRouteRouteRoute,
} as any).lazy(() =>
  import('./routes/_private/_route/profile/lazy').then((d) => d.Route),
)

const PrivateRouteInternalRouteRoute = PrivateRouteInternalRouteImport.update({
  id: '/_internal',
  getParentRoute: () => PrivateRouteRouteRoute,
} as any).lazy(() =>
  import('./routes/_private/_route/_internal/lazy').then((d) => d.Route),
)

const PrivateRouteSplatRouteRoute = PrivateRouteSplatRouteImport.update({
  path: '/$',
  getParentRoute: () => PrivateRouteRouteRoute,
} as any).lazy(() =>
  import('./routes/_private/_route/$.lazy').then((d) => d.Route),
)

const PrivateAuthSetPasswordRouteRoute =
  PrivateAuthSetPasswordRouteImport.update({
    path: '/set-password',
    getParentRoute: () => PrivateAuthLazyRoute,
  } as any)

const PrivateTeamsTeamIdIndexRouteRoute =
  PrivateTeamsTeamIdIndexRouteImport.update({
    path: '/teams/$teamId/',
    getParentRoute: () => PrivateRouteRoute,
  } as any)

const PrivateRouteUsersIndexRouteRoute =
  PrivateRouteUsersIndexRouteImport.update({
    path: '/users/',
    getParentRoute: () => PrivateRouteRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/users/index.lazy').then((d) => d.Route),
  )

const PrivateRouteProfileIndexRouteRoute =
  PrivateRouteProfileIndexRouteImport.update({
    path: '/',
    getParentRoute: () => PrivateRouteProfileRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/profile/index.lazy').then((d) => d.Route),
  )

const PrivateAuthSignupIndexRouteRoute =
  PrivateAuthSignupIndexRouteImport.update({
    path: '/signup/',
    getParentRoute: () => PrivateAuthLazyRoute,
  } as any).lazy(() =>
    import('./routes/_private/_auth/signup/index.lazy').then((d) => d.Route),
  )

const LayoutAuthGuestLoginIndexRouteRoute =
  LayoutAuthGuestLoginIndexRouteImport.update({
    path: '/login/',
    getParentRoute: () => LayoutAuthGuestRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layoutAuth/_guest/login/index.lazy').then((d) => d.Route),
  )

const LayoutAuthGuestJoinIndexRouteRoute =
  LayoutAuthGuestJoinIndexRouteImport.update({
    path: '/join/',
    getParentRoute: () => LayoutAuthGuestRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layoutAuth/_guest/join/index.lazy').then((d) => d.Route),
  )

const LayoutAuthGuestEmailResponseIndexRouteRoute =
  LayoutAuthGuestEmailResponseIndexRouteImport.update({
    path: '/email-response/',
    getParentRoute: () => LayoutAuthGuestRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layoutAuth/_guest/email-response/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteUsersUserIdRouteRoute =
  PrivateRouteUsersUserIdRouteImport.update({
    path: '/users/$userId',
    getParentRoute: () => PrivateRouteRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/users/$userId/lazy').then((d) => d.Route),
  )

const PrivateRouteTeamsTeamIdRouteRoute =
  PrivateRouteTeamsTeamIdRouteImport.update({
    path: '/teams/$teamId',
    getParentRoute: () => PrivateRouteRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/lazy').then((d) => d.Route),
  )

const PrivateRouteInternalTrendingRouteRoute =
  PrivateRouteInternalTrendingRouteImport.update({
    path: '/trending',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/trending/lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalTasksRouteRoute =
  PrivateRouteInternalTasksRouteImport.update({
    path: '/tasks',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/tasks/lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalPipelinesRouteRoute =
  PrivateRouteInternalPipelinesRouteImport.update({
    path: '/pipelines',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/pipelines/lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalEventsRouteRoute =
  PrivateRouteInternalEventsRouteImport.update({
    path: '/events',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/events/lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalAdminRouteRoute =
  PrivateRouteInternalAdminRouteImport.update({
    path: '/admin',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any)

const PrivateRouteUsersNewIndexRouteRoute =
  PrivateRouteUsersNewIndexRouteImport.update({
    path: '/users/new/',
    getParentRoute: () => PrivateRouteRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/users/new/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteUsersUserIdIndexRouteRoute =
  PrivateRouteUsersUserIdIndexRouteImport.update({
    path: '/',
    getParentRoute: () => PrivateRouteUsersUserIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/users/$userId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteProfileTeamsIndexRouteRoute =
  PrivateRouteProfileTeamsIndexRouteImport.update({
    path: '/teams/',
    getParentRoute: () => PrivateRouteProfileRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/profile/teams/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalTrendingIndexRouteRoute =
  PrivateRouteInternalTrendingIndexRouteImport.update({
    path: '/',
    getParentRoute: () => PrivateRouteInternalTrendingRouteRoute,
  } as any)

const PrivateRouteInternalToolsIndexRouteRoute =
  PrivateRouteInternalToolsIndexRouteImport.update({
    path: '/tools/',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/tools/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalTasksIndexRouteRoute =
  PrivateRouteInternalTasksIndexRouteImport.update({
    path: '/',
    getParentRoute: () => PrivateRouteInternalTasksRouteRoute,
  } as any)

const PrivateRouteInternalSearchesIndexRouteRoute =
  PrivateRouteInternalSearchesIndexRouteImport.update({
    path: '/searches/',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any)

const PrivateRouteInternalSearchSubmissionsIndexRouteRoute =
  PrivateRouteInternalSearchSubmissionsIndexRouteImport.update({
    path: '/search-submissions/',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any)

const PrivateRouteInternalPipelineSubmissionsIndexRouteRoute =
  PrivateRouteInternalPipelineSubmissionsIndexRouteImport.update({
    path: '/pipeline-submissions/',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any)

const PrivateRouteInternalPerformanceIndexRouteRoute =
  PrivateRouteInternalPerformanceIndexRouteImport.update({
    path: '/performance/',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/performance/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalPeopleIndexRouteRoute =
  PrivateRouteInternalPeopleIndexRouteImport.update({
    path: '/people/',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/people/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalPeersIndexRouteRoute =
  PrivateRouteInternalPeersIndexRouteImport.update({
    path: '/peers/',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/peers/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalIntroductionsIndexRouteRoute =
  PrivateRouteInternalIntroductionsIndexRouteImport.update({
    path: '/introductions/',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any)

const PrivateRouteInternalHomeIndexRouteRoute =
  PrivateRouteInternalHomeIndexRouteImport.update({
    path: '/home/',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/home/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalExperimentsIndexRouteRoute =
  PrivateRouteInternalExperimentsIndexRouteImport.update({
    path: '/experiments/',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/experiments/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalEventsIndexRouteRoute =
  PrivateRouteInternalEventsIndexRouteImport.update({
    path: '/',
    getParentRoute: () => PrivateRouteInternalEventsRouteRoute,
  } as any)

const PrivateRouteInternalCompaniesIndexRouteRoute =
  PrivateRouteInternalCompaniesIndexRouteImport.update({
    path: '/companies/',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/companies/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteTeamsTeamIdTrendingLazyRoute =
  PrivateRouteTeamsTeamIdTrendingLazyImport.update({
    path: '/trending',
    getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/trending/lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteUsersUserIdTrendingRouteRoute =
  PrivateRouteUsersUserIdTrendingRouteImport.update({
    path: '/trending',
    getParentRoute: () => PrivateRouteUsersUserIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/users/$userId/trending/lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteUsersUserIdPeopleRouteRoute =
  PrivateRouteUsersUserIdPeopleRouteImport.update({
    path: '/people',
    getParentRoute: () => PrivateRouteUsersUserIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/users/$userId/people/lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteTeamsTeamIdNetworkRouteRoute =
  PrivateRouteTeamsTeamIdNetworkRouteImport.update({
    path: '/network',
    getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
  } as any)

const PrivateRouteTeamsTeamIdCandidatesRouteRoute =
  PrivateRouteTeamsTeamIdCandidatesRouteImport.update({
    path: '/candidates',
    getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/candidates/lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalPipelinesNewRouteRoute =
  PrivateRouteInternalPipelinesNewRouteImport.update({
    path: '/pipelines/new',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/pipelines_/new/lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalPeopleIdentityIdRouteRoute =
  PrivateRouteInternalPeopleIdentityIdRouteImport.update({
    path: '/people/$identityId',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/people/$identityId/lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalEventsEventIdRouteRoute =
  PrivateRouteInternalEventsEventIdRouteImport.update({
    path: '/$eventId',
    getParentRoute: () => PrivateRouteInternalEventsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/events/$eventId/lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalCandidatesCandidateIdRouteRoute =
  PrivateRouteInternalCandidatesCandidateIdRouteImport.update({
    path: '/candidates/$candidateId',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any)

const PrivateRouteInternalPipelinesIndexRouteRoute =
  PrivateRouteInternalPipelinesIndexRouteImport.update({
    path: '/',
    getParentRoute: () => PrivateRouteInternalPipelinesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/pipelines/index/lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteUsersUserIdTrendingIndexRoute =
  PrivateRouteUsersUserIdTrendingIndexImport.update({
    path: '/',
    getParentRoute: () => PrivateRouteUsersUserIdTrendingRouteRoute,
  } as any)

const PrivateRouteTeamsTeamIdTrendingIndexRoute =
  PrivateRouteTeamsTeamIdTrendingIndexImport.update({
    path: '/',
    getParentRoute: () => PrivateRouteTeamsTeamIdTrendingLazyRoute,
  } as any)

const PrivateRouteUsersUserIdSettingsIndexRouteRoute =
  PrivateRouteUsersUserIdSettingsIndexRouteImport.update({
    path: '/settings/',
    getParentRoute: () => PrivateRouteUsersUserIdRouteRoute,
  } as any)

const PrivateRouteUsersUserIdPipelinesIndexRouteRoute =
  PrivateRouteUsersUserIdPipelinesIndexRouteImport.update({
    path: '/pipelines/',
    getParentRoute: () => PrivateRouteUsersUserIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/users/$userId/pipelines/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteUsersUserIdEventsIndexRouteRoute =
  PrivateRouteUsersUserIdEventsIndexRouteImport.update({
    path: '/events/',
    getParentRoute: () => PrivateRouteUsersUserIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/users/$userId/events/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteTeamsTeamIdSettingsIndexRouteRoute =
  PrivateRouteTeamsTeamIdSettingsIndexRouteImport.update({
    path: '/settings/',
    getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/settings/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteTeamsTeamIdSearchesIndexRouteRoute =
  PrivateRouteTeamsTeamIdSearchesIndexRouteImport.update({
    path: '/searches/',
    getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
  } as any)

const PrivateRouteTeamsTeamIdPipelinesIndexRouteRoute =
  PrivateRouteTeamsTeamIdPipelinesIndexRouteImport.update({
    path: '/pipelines/',
    getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/pipelines/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteTeamsTeamIdIntroductionsIndexRouteRoute =
  PrivateRouteTeamsTeamIdIntroductionsIndexRouteImport.update({
    path: '/introductions/',
    getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
  } as any)

const PrivateRouteTeamsTeamIdHomeIndexRouteRoute =
  PrivateRouteTeamsTeamIdHomeIndexRouteImport.update({
    path: '/home/',
    getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/home/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalTrendingPeopleIndexRouteRoute =
  PrivateRouteInternalTrendingPeopleIndexRouteImport.update({
    path: '/people/',
    getParentRoute: () => PrivateRouteInternalTrendingRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/trending/people/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalTrendingNewIndexRouteRoute =
  PrivateRouteInternalTrendingNewIndexRouteImport.update({
    path: '/new/',
    getParentRoute: () => PrivateRouteInternalTrendingRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/trending/new/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalTrendingCampaignsIndexRouteRoute =
  PrivateRouteInternalTrendingCampaignsIndexRouteImport.update({
    path: '/campaigns/',
    getParentRoute: () => PrivateRouteInternalTrendingRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/trending/campaigns/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalTrendingSubmissionIdIndexRouteRoute =
  PrivateRouteInternalTrendingSubmissionIdIndexRouteImport.update({
    path: '/$submissionId/',
    getParentRoute: () => PrivateRouteInternalTrendingRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/trending/$submissionId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalToolsPathwayActivityDefaultsIndexRouteRoute =
  PrivateRouteInternalToolsPathwayActivityDefaultsIndexRouteImport.update({
    path: '/tools/pathway-activity-defaults/',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/tools/pathway-activity-defaults/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalToolsMoveTeamIndexRouteRoute =
  PrivateRouteInternalToolsMoveTeamIndexRouteImport.update({
    path: '/tools/move-team/',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/tools/move-team/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalToolsMergePeopleIndexRouteRoute =
  PrivateRouteInternalToolsMergePeopleIndexRouteImport.update({
    path: '/tools/merge-people/',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/tools/merge-people/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalToolsMarketSearchesIndexRouteRoute =
  PrivateRouteInternalToolsMarketSearchesIndexRouteImport.update({
    path: '/tools/market-searches/',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/tools/market-searches/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalToolsEmailTemplatesIndexRouteRoute =
  PrivateRouteInternalToolsEmailTemplatesIndexRouteImport.update({
    path: '/tools/email-templates/',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/tools/email-templates/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalToolsAiCandidateDiscoveryIndexRouteRoute =
  PrivateRouteInternalToolsAiCandidateDiscoveryIndexRouteImport.update({
    path: '/tools/ai-candidate-discovery/',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/tools/ai-candidate-discovery/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalTasksMeIndexRouteRoute =
  PrivateRouteInternalTasksMeIndexRouteImport.update({
    path: '/me/',
    getParentRoute: () => PrivateRouteInternalTasksRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/tasks/me/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalTasksExecutiveServicesIndexRouteRoute =
  PrivateRouteInternalTasksExecutiveServicesIndexRouteImport.update({
    path: '/executive-services/',
    getParentRoute: () => PrivateRouteInternalTasksRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/tasks/executive-services/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalPipelineSubmissionsSubmissionIdIndexRouteRoute =
  PrivateRouteInternalPipelineSubmissionsSubmissionIdIndexRouteImport.update({
    path: '/pipeline-submissions/$submissionId/',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any)

const PrivateRouteInternalPeopleIdentityIdIndexRouteRoute =
  PrivateRouteInternalPeopleIdentityIdIndexRouteImport.update({
    path: '/',
    getParentRoute: () => PrivateRouteInternalPeopleIdentityIdRouteRoute,
  } as any)

const PrivateRouteInternalPeersNewIndexRouteRoute =
  PrivateRouteInternalPeersNewIndexRouteImport.update({
    path: '/peers/new/',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/peers/new/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalIntroductionSubmissionsSubmissionIdIndexRouteRoute =
  PrivateRouteInternalIntroductionSubmissionsSubmissionIdIndexRouteImport.update(
    {
      path: '/introduction-submissions/$submissionId/',
      getParentRoute: () => PrivateRouteInternalRouteRoute,
    } as any,
  )

const PrivateRouteInternalEventsSettingsIndexRouteRoute =
  PrivateRouteInternalEventsSettingsIndexRouteImport.update({
    path: '/settings/',
    getParentRoute: () => PrivateRouteInternalEventsRouteRoute,
  } as any)

const PrivateRouteInternalEventsParticipantsIndexRouteRoute =
  PrivateRouteInternalEventsParticipantsIndexRouteImport.update({
    path: '/participants/',
    getParentRoute: () => PrivateRouteInternalEventsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/events/participants/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalEventsNewIndexRouteRoute =
  PrivateRouteInternalEventsNewIndexRouteImport.update({
    path: '/new/',
    getParentRoute: () => PrivateRouteInternalEventsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/events/new/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalEventsEventsIndexRouteRoute =
  PrivateRouteInternalEventsEventsIndexRouteImport.update({
    path: '/events/',
    getParentRoute: () => PrivateRouteInternalEventsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/events/events/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalEventsEventIdIndexRouteRoute =
  PrivateRouteInternalEventsEventIdIndexRouteImport.update({
    path: '/',
    getParentRoute: () => PrivateRouteInternalEventsEventIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/events/$eventId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalCandidatesNewIndexRouteRoute =
  PrivateRouteInternalCandidatesNewIndexRouteImport.update({
    path: '/candidates/new/',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/candidates/new/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalCandidatesCandidateIdIndexRouteRoute =
  PrivateRouteInternalCandidatesCandidateIdIndexRouteImport.update({
    path: '/',
    getParentRoute: () => PrivateRouteInternalCandidatesCandidateIdRouteRoute,
  } as any)

const PrivateRouteInternalAdminUsersIndexRouteRoute =
  PrivateRouteInternalAdminUsersIndexRouteImport.update({
    path: '/users/',
    getParentRoute: () => PrivateRouteInternalAdminRouteRoute,
  } as any)

const PrivateRouteTeamsTeamIdPipelinesPipelineIdLazyRoute =
  PrivateRouteTeamsTeamIdPipelinesPipelineIdLazyImport.update({
    path: '/pipelines/$pipelineId',
    getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/pipelines/$pipelineId/lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteUsersUserIdPipelinesNewRouteRoute =
  PrivateRouteUsersUserIdPipelinesNewRouteImport.update({
    path: '/pipelines/new',
    getParentRoute: () => PrivateRouteUsersUserIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/users/$userId/pipelines/new.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteUsersUserIdPeopleCandidateIdRouteRoute =
  PrivateRouteUsersUserIdPeopleCandidateIdRouteImport.update({
    path: '/$candidateId',
    getParentRoute: () => PrivateRouteUsersUserIdPeopleRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/users/$userId/people/$candidateId/lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteTeamsTeamIdPipelinesNewRouteRoute =
  PrivateRouteTeamsTeamIdPipelinesNewRouteImport.update({
    path: '/pipelines/new',
    getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/pipelines/new.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteRoute =
  PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteImport.update({
    path: '/$candidateId',
    getParentRoute: () => PrivateRouteTeamsTeamIdCandidatesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/candidates/$candidateId/lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalPeopleIdentityIdCandidateRouteRoute =
  PrivateRouteInternalPeopleIdentityIdCandidateRouteImport.update({
    id: '/_candidate',
    getParentRoute: () => PrivateRouteInternalPeopleIdentityIdRouteRoute,
  } as any)

const PrivateRouteInternalEventsParticipantsParticipantIdRouteRoute =
  PrivateRouteInternalEventsParticipantsParticipantIdRouteImport.update({
    path: '/participants/$participantId',
    getParentRoute: () => PrivateRouteInternalEventsRouteRoute,
  } as any)

const PrivateRouteInternalEventsEventIdParticipantsRouteRoute =
  PrivateRouteInternalEventsEventIdParticipantsRouteImport.update({
    path: '/participants',
    getParentRoute: () => PrivateRouteInternalEventsEventIdRouteRoute,
  } as any)

const PrivateRouteInternalCandidatesCandidateIdTasksRouteRoute =
  PrivateRouteInternalCandidatesCandidateIdTasksRouteImport.update({
    path: '/tasks',
    getParentRoute: () => PrivateRouteInternalCandidatesCandidateIdRouteRoute,
  } as any)

const PrivateRouteInternalAdminUsersUserIdRouteRoute =
  PrivateRouteInternalAdminUsersUserIdRouteImport.update({
    path: '/users/$userId',
    getParentRoute: () => PrivateRouteInternalAdminRouteRoute,
  } as any)

const PrivateRouteUsersUserIdTrendingRecommendationIdIndexRouteRoute =
  PrivateRouteUsersUserIdTrendingRecommendationIdIndexRouteImport.update({
    path: '/$recommendationId/',
    getParentRoute: () => PrivateRouteUsersUserIdTrendingRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/users/$userId/trending/$recommendationId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteUsersUserIdPipelinesPipelineIdIndexRouteRoute =
  PrivateRouteUsersUserIdPipelinesPipelineIdIndexRouteImport.update({
    path: '/pipelines/$pipelineId/',
    getParentRoute: () => PrivateRouteUsersUserIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/users/$userId/pipelines/$pipelineId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteUsersUserIdEventsEventIdIndexRouteRoute =
  PrivateRouteUsersUserIdEventsEventIdIndexRouteImport.update({
    path: '/events/$eventId/',
    getParentRoute: () => PrivateRouteUsersUserIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/users/$userId/events/$eventId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteTeamsTeamIdTrendingRecommendationIdIndexRouteRoute =
  PrivateRouteTeamsTeamIdTrendingRecommendationIdIndexRouteImport.update({
    path: '/$recommendationId/',
    getParentRoute: () => PrivateRouteTeamsTeamIdTrendingLazyRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/trending/$recommendationId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteTeamsTeamIdSearchesSearchIdIndexRouteRoute =
  PrivateRouteTeamsTeamIdSearchesSearchIdIndexRouteImport.update({
    path: '/searches/$searchId/',
    getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
  } as any)

const PrivateRouteTeamsTeamIdIntroductionsCandidateIdIndexRouteRoute =
  PrivateRouteTeamsTeamIdIntroductionsCandidateIdIndexRouteImport.update({
    path: '/introductions/$candidateId/',
    getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
  } as any)

const PrivateRouteTeamsTeamIdCandidatesCandidateIdIndexRouteRoute =
  PrivateRouteTeamsTeamIdCandidatesCandidateIdIndexRouteImport.update({
    path: '/',
    getParentRoute: () =>
      PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteRoute,
  } as any)

const PrivateRouteInternalTrendingSubmissionIdEditIndexRouteRoute =
  PrivateRouteInternalTrendingSubmissionIdEditIndexRouteImport.update({
    path: '/$submissionId/edit/',
    getParentRoute: () => PrivateRouteInternalTrendingRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/trending/$submissionId/edit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalPeopleIdentityIdEmailsIndexRouteRoute =
  PrivateRouteInternalPeopleIdentityIdEmailsIndexRouteImport.update({
    path: '/emails/',
    getParentRoute: () => PrivateRouteInternalPeopleIdentityIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/people/$identityId/emails/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalPeopleIdentityIdAccountsIndexRouteRoute =
  PrivateRouteInternalPeopleIdentityIdAccountsIndexRouteImport.update({
    path: '/accounts/',
    getParentRoute: () => PrivateRouteInternalPeopleIdentityIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/people/$identityId/accounts/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalEventsParticipantsParticipantIdIndexRouteRoute =
  PrivateRouteInternalEventsParticipantsParticipantIdIndexRouteImport.update({
    path: '/',
    getParentRoute: () =>
      PrivateRouteInternalEventsParticipantsParticipantIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/events/participants/$participantId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalEventsEventIdEmailsIndexRouteRoute =
  PrivateRouteInternalEventsEventIdEmailsIndexRouteImport.update({
    path: '/emails/',
    getParentRoute: () => PrivateRouteInternalEventsEventIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/events/$eventId/emails/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalEventsEventIdEmailSettingsIndexRouteRoute =
  PrivateRouteInternalEventsEventIdEmailSettingsIndexRouteImport.update({
    path: '/email-settings/',
    getParentRoute: () => PrivateRouteInternalEventsEventIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/events/$eventId/email-settings/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalEventsEventIdDetailsIndexRouteRoute =
  PrivateRouteInternalEventsEventIdDetailsIndexRouteImport.update({
    path: '/details/',
    getParentRoute: () => PrivateRouteInternalEventsEventIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/events/$eventId/details/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalCompaniesCompanyIdSettingsIndexRouteRoute =
  PrivateRouteInternalCompaniesCompanyIdSettingsIndexRouteImport.update({
    path: '/companies/$companyId/settings/',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/companies/$companyId/settings/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalCompaniesCompanyIdPeopleIndexRouteRoute =
  PrivateRouteInternalCompaniesCompanyIdPeopleIndexRouteImport.update({
    path: '/companies/$companyId/people/',
    getParentRoute: () => PrivateRouteInternalRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/companies/$companyId/people/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalCandidatesCandidateIdSuggestedPipelinesIndexRouteRoute =
  PrivateRouteInternalCandidatesCandidateIdSuggestedPipelinesIndexRouteImport.update(
    {
      path: '/suggested-pipelines/',
      getParentRoute: () => PrivateRouteInternalCandidatesCandidateIdRouteRoute,
    } as any,
  )

const PrivateRouteInternalCandidatesCandidateIdRecommendationsIndexRouteRoute =
  PrivateRouteInternalCandidatesCandidateIdRecommendationsIndexRouteImport.update(
    {
      path: '/recommendations/',
      getParentRoute: () => PrivateRouteInternalCandidatesCandidateIdRouteRoute,
    } as any,
  )

const PrivateRouteInternalCandidatesCandidateIdProfileIndexRouteRoute =
  PrivateRouteInternalCandidatesCandidateIdProfileIndexRouteImport.update({
    path: '/profile/',
    getParentRoute: () => PrivateRouteInternalCandidatesCandidateIdRouteRoute,
  } as any)

const PrivateRouteInternalCandidatesCandidateIdPerformanceIndexRouteRoute =
  PrivateRouteInternalCandidatesCandidateIdPerformanceIndexRouteImport.update({
    path: '/performance/',
    getParentRoute: () => PrivateRouteInternalCandidatesCandidateIdRouteRoute,
  } as any)

const PrivateRouteInternalCandidatesCandidateIdFeedbackIndexRouteRoute =
  PrivateRouteInternalCandidatesCandidateIdFeedbackIndexRouteImport.update({
    path: '/feedback/',
    getParentRoute: () => PrivateRouteInternalCandidatesCandidateIdRouteRoute,
  } as any)

const PrivateRouteInternalCandidatesCandidateIdCompareIndexRouteRoute =
  PrivateRouteInternalCandidatesCandidateIdCompareIndexRouteImport.update({
    path: '/compare/',
    getParentRoute: () => PrivateRouteInternalCandidatesCandidateIdRouteRoute,
  } as any)

const PrivateRouteInternalCandidatesCandidateIdAccountsIndexRouteRoute =
  PrivateRouteInternalCandidatesCandidateIdAccountsIndexRouteImport.update({
    path: '/accounts/',
    getParentRoute: () => PrivateRouteInternalCandidatesCandidateIdRouteRoute,
  } as any)

const PrivateRouteInternalCandidatesCandidateIdAboutIndexRouteRoute =
  PrivateRouteInternalCandidatesCandidateIdAboutIndexRouteImport.update({
    path: '/about/',
    getParentRoute: () => PrivateRouteInternalCandidatesCandidateIdRouteRoute,
  } as any)

const PrivateRouteInternalAdminUsersNewIndexRouteRoute =
  PrivateRouteInternalAdminUsersNewIndexRouteImport.update({
    path: '/users/new/',
    getParentRoute: () => PrivateRouteInternalAdminRouteRoute,
  } as any)

const PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalLazyRoute =
  PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalLazyImport.update({
    id: '/_internal',
    getParentRoute: () => PrivateRouteTeamsTeamIdPipelinesPipelineIdLazyRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteUsersUserIdPipelinesPipelineIdEditRouteRoute =
  PrivateRouteUsersUserIdPipelinesPipelineIdEditRouteImport.update({
    path: '/pipelines/$pipelineId/edit',
    getParentRoute: () => PrivateRouteUsersUserIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/users/$userId/pipelines/$pipelineId/edit.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteTeamsTeamIdPipelinesPipelineIdEditRouteRoute =
  PrivateRouteTeamsTeamIdPipelinesPipelineIdEditRouteImport.update({
    path: '/pipelines/$pipelineId/edit',
    getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/pipelines_/$pipelineId/edit.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteTeamsTeamIdCandidatesCandidateIdTabIdRouteRoute =
  PrivateRouteTeamsTeamIdCandidatesCandidateIdTabIdRouteImport.update({
    path: '/$tabId',
    getParentRoute: () =>
      PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteRoute,
  } as any)

const PrivateRouteInternalPeopleIdentityIdCandidateTasksRouteRoute =
  PrivateRouteInternalPeopleIdentityIdCandidateTasksRouteImport.update({
    path: '/tasks',
    getParentRoute: () =>
      PrivateRouteInternalPeopleIdentityIdCandidateRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/people/$identityId/_candidate/tasks/lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalPeopleIdentityIdCandidateTasksIndexLazyRoute =
  PrivateRouteInternalPeopleIdentityIdCandidateTasksIndexLazyImport.update({
    path: '/',
    getParentRoute: () =>
      PrivateRouteInternalPeopleIdentityIdCandidateTasksRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/people/$identityId/_candidate/tasks/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteTeamsTeamIdCandidatesCandidateIdPipelinesIndexRouteRoute =
  PrivateRouteTeamsTeamIdCandidatesCandidateIdPipelinesIndexRouteImport.update({
    path: '/pipelines/',
    getParentRoute: () =>
      PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/candidates/$candidateId/pipelines/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteTeamsTeamIdCandidatesCandidateIdActivityIndexRouteRoute =
  PrivateRouteTeamsTeamIdCandidatesCandidateIdActivityIndexRouteImport.update({
    path: '/activity/',
    getParentRoute: () =>
      PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/candidates/$candidateId/activity/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalPeopleIdentityIdCandidateSuggestedPipelinesIndexRouteRoute =
  PrivateRouteInternalPeopleIdentityIdCandidateSuggestedPipelinesIndexRouteImport.update(
    {
      path: '/suggested-pipelines/',
      getParentRoute: () =>
        PrivateRouteInternalPeopleIdentityIdCandidateRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_private/_route/_internal/people/$identityId/_candidate/suggested-pipelines/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalPeopleIdentityIdCandidateRecommendationsIndexRouteRoute =
  PrivateRouteInternalPeopleIdentityIdCandidateRecommendationsIndexRouteImport.update(
    {
      path: '/recommendations/',
      getParentRoute: () =>
        PrivateRouteInternalPeopleIdentityIdCandidateRouteRoute,
    } as any,
  )

const PrivateRouteInternalPeopleIdentityIdCandidateProfileIndexRouteRoute =
  PrivateRouteInternalPeopleIdentityIdCandidateProfileIndexRouteImport.update({
    path: '/profile/',
    getParentRoute: () =>
      PrivateRouteInternalPeopleIdentityIdCandidateRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/people/$identityId/_candidate/profile/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalPeopleIdentityIdCandidatePerformanceIndexRouteRoute =
  PrivateRouteInternalPeopleIdentityIdCandidatePerformanceIndexRouteImport.update(
    {
      path: '/performance/',
      getParentRoute: () =>
        PrivateRouteInternalPeopleIdentityIdCandidateRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_private/_route/_internal/people/$identityId/_candidate/performance/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalPeopleIdentityIdCandidateFeedbackIndexRouteRoute =
  PrivateRouteInternalPeopleIdentityIdCandidateFeedbackIndexRouteImport.update({
    path: '/feedback/',
    getParentRoute: () =>
      PrivateRouteInternalPeopleIdentityIdCandidateRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/people/$identityId/_candidate/feedback/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalPeopleIdentityIdCandidateCompareIndexRouteRoute =
  PrivateRouteInternalPeopleIdentityIdCandidateCompareIndexRouteImport.update({
    path: '/compare/',
    getParentRoute: () =>
      PrivateRouteInternalPeopleIdentityIdCandidateRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/people/$identityId/_candidate/compare/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalPeopleIdentityIdCandidateAboutIndexRouteRoute =
  PrivateRouteInternalPeopleIdentityIdCandidateAboutIndexRouteImport.update({
    path: '/about/',
    getParentRoute: () =>
      PrivateRouteInternalPeopleIdentityIdCandidateRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/people/$identityId/_candidate/about/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalEventsEventIdParticipantsNewIndexRouteRoute =
  PrivateRouteInternalEventsEventIdParticipantsNewIndexRouteImport.update({
    path: '/new/',
    getParentRoute: () =>
      PrivateRouteInternalEventsEventIdParticipantsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/_internal/events/$eventId/participants/new/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalAdminUsersUserIdSettingsIndexRouteRoute =
  PrivateRouteInternalAdminUsersUserIdSettingsIndexRouteImport.update({
    path: '/settings/',
    getParentRoute: () => PrivateRouteInternalAdminUsersUserIdRouteRoute,
  } as any)

const PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsNewRouteRoute =
  PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsNewRouteImport.update(
    {
      path: '/pipelines/$pipelineId/recommendations/new',
      getParentRoute: () => PrivateRouteUsersUserIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_private/_route/users/$userId/pipelines/$pipelineId_/recommendations/new/lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteTeamsTeamIdPipelinesPipelineIdRecommendationsNewRouteRoute =
  PrivateRouteTeamsTeamIdPipelinesPipelineIdRecommendationsNewRouteImport.update(
    {
      path: '/pipelines/$pipelineId/recommendations/new',
      getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/pipelines/$pipelineId_/recommendations/new/lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRouteRoute =
  PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRouteImport.update(
    {
      path: '/recommendations',
      getParentRoute: () =>
        PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalLazyRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations/lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalIndexRouteRoute =
  PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalIndexRouteImport.update({
    path: '/',
    getParentRoute: () =>
      PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalLazyRoute,
  } as any).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/index/lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsRecommendationIdIndexRouteRoute =
  PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsRecommendationIdIndexRouteImport.update(
    {
      path: '/pipelines/$pipelineId/recommendations/$recommendationId/',
      getParentRoute: () => PrivateRouteUsersUserIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_private/_route/users/$userId/pipelines/$pipelineId/recommendations.$recommendationId.index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteTeamsTeamIdSearchesSearchIdCandidatesCandidateIdIndexRouteRoute =
  PrivateRouteTeamsTeamIdSearchesSearchIdCandidatesCandidateIdIndexRouteImport.update(
    {
      path: '/searches/$searchId/candidates/$candidateId/',
      getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
    } as any,
  )

const PrivateRouteTeamsTeamIdPipelinesPipelineIdSubmissionsSubmissionIdIndexRouteRoute =
  PrivateRouteTeamsTeamIdPipelinesPipelineIdSubmissionsSubmissionIdIndexRouteImport.update(
    {
      path: '/pipelines/$pipelineId/submissions/$submissionId/',
      getParentRoute: () => PrivateRouteTeamsTeamIdRouteRoute,
    } as any,
  )

const PrivateRouteTeamsTeamIdPipelinesPipelineIdIntroductionsCandidateIdIndexRouteRoute =
  PrivateRouteTeamsTeamIdPipelinesPipelineIdIntroductionsCandidateIdIndexRouteImport.update(
    {
      path: '/introductions/$candidateId/',
      getParentRoute: () => PrivateRouteTeamsTeamIdPipelinesPipelineIdLazyRoute,
    } as any,
  )

const PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsIndexRouteRoute =
  PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsIndexRouteImport.update(
    {
      path: '/',
      getParentRoute: () =>
        PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalCandidatesCandidateIdTasksGoalsGoalIdIndexRouteRoute =
  PrivateRouteInternalCandidatesCandidateIdTasksGoalsGoalIdIndexRouteImport.update(
    {
      path: '/goals/$goalId/',
      getParentRoute: () =>
        PrivateRouteInternalCandidatesCandidateIdTasksRouteRoute,
    } as any,
  )

const PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRecommendationIdIndexRouteRoute =
  PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRecommendationIdIndexRouteImport.update(
    {
      path: '/$recommendationId/',
      getParentRoute: () =>
        PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations/$recommendationId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateRouteInternalTeamsTeamIdSearchesSearchIdSubmissionsSubmissionIdIndexRouteRoute =
  PrivateRouteInternalTeamsTeamIdSearchesSearchIdSubmissionsSubmissionIdIndexRouteImport.update(
    {
      path: '/teams/$teamId/searches/$searchId/submissions/$submissionId/',
      getParentRoute: () => PrivateRouteInternalRouteRoute,
    } as any,
  )

const PrivateRouteInternalPeopleIdentityIdCandidateTasksGoalsGoalIdIndexRouteRoute =
  PrivateRouteInternalPeopleIdentityIdCandidateTasksGoalsGoalIdIndexRouteImport.update(
    {
      path: '/goals/$goalId/',
      getParentRoute: () =>
        PrivateRouteInternalPeopleIdentityIdCandidateTasksRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_private/_route/_internal/people/$identityId/_candidate/tasks/goals/$goalId/index.lazy').then(
      (d) => d.Route,
    ),
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_layoutAuth': {
      id: '/_layoutAuth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutAuthRouteImport
      parentRoute: typeof rootRoute
    }
    '/_private': {
      id: '/_private'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PrivateRouteImport
      parentRoute: typeof rootRoute
    }
    '/events': {
      id: '/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof EventsRouteImport
      parentRoute: typeof rootRoute
    }
    '/registration': {
      id: '/registration'
      path: '/registration'
      fullPath: '/registration'
      preLoaderRoute: typeof RegistrationRouteImport
      parentRoute: typeof rootRoute
    }
    '/_layoutAuth/_guest': {
      id: '/_layoutAuth/_guest'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutAuthGuestRouteImport
      parentRoute: typeof LayoutAuthRouteImport
    }
    '/_private/_route': {
      id: '/_private/_route'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PrivateRouteRouteImport
      parentRoute: typeof PrivateRouteImport
    }
    '/events/rsvp': {
      id: '/events/rsvp'
      path: '/rsvp'
      fullPath: '/events/rsvp'
      preLoaderRoute: typeof EventsRsvpRouteImport
      parentRoute: typeof EventsRouteImport
    }
    '/_private/_auth': {
      id: '/_private/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PrivateAuthLazyImport
      parentRoute: typeof PrivateRouteImport
    }
    '/_private/': {
      id: '/_private/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PrivateIndexRouteImport
      parentRoute: typeof PrivateRouteImport
    }
    '/_private/_auth/set-password': {
      id: '/_private/_auth/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof PrivateAuthSetPasswordRouteImport
      parentRoute: typeof PrivateAuthLazyImport
    }
    '/_private/_route/$': {
      id: '/_private/_route/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof PrivateRouteSplatRouteImport
      parentRoute: typeof PrivateRouteRouteImport
    }
    '/_private/_route/_internal': {
      id: '/_private/_route/_internal'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PrivateRouteInternalRouteImport
      parentRoute: typeof PrivateRouteRouteImport
    }
    '/_private/_route/profile': {
      id: '/_private/_route/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof PrivateRouteProfileRouteImport
      parentRoute: typeof PrivateRouteRouteImport
    }
    '/_layoutAuth/exec-access-disabled/': {
      id: '/_layoutAuth/exec-access-disabled/'
      path: '/exec-access-disabled'
      fullPath: '/exec-access-disabled'
      preLoaderRoute: typeof LayoutAuthExecAccessDisabledIndexRouteImport
      parentRoute: typeof LayoutAuthRouteImport
    }
    '/_layoutAuth/logout/': {
      id: '/_layoutAuth/logout/'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LayoutAuthLogoutIndexRouteImport
      parentRoute: typeof LayoutAuthRouteImport
    }
    '/_layoutAuth/maintenance/': {
      id: '/_layoutAuth/maintenance/'
      path: '/maintenance'
      fullPath: '/maintenance'
      preLoaderRoute: typeof LayoutAuthMaintenanceIndexRouteImport
      parentRoute: typeof LayoutAuthRouteImport
    }
    '/_layoutAuth/unsupported-account/': {
      id: '/_layoutAuth/unsupported-account/'
      path: '/unsupported-account'
      fullPath: '/unsupported-account'
      preLoaderRoute: typeof LayoutAuthUnsupportedAccountIndexRouteImport
      parentRoute: typeof LayoutAuthRouteImport
    }
    '/_private/teams/': {
      id: '/_private/teams/'
      path: '/teams'
      fullPath: '/teams'
      preLoaderRoute: typeof PrivateTeamsIndexRouteImport
      parentRoute: typeof PrivateRouteImport
    }
    '/_private/_route/_internal/admin': {
      id: '/_private/_route/_internal/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof PrivateRouteInternalAdminRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/_internal/events': {
      id: '/_private/_route/_internal/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof PrivateRouteInternalEventsRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/_internal/pipelines': {
      id: '/_private/_route/_internal/pipelines'
      path: '/pipelines'
      fullPath: '/pipelines'
      preLoaderRoute: typeof PrivateRouteInternalPipelinesRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/_internal/tasks': {
      id: '/_private/_route/_internal/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof PrivateRouteInternalTasksRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/_internal/trending': {
      id: '/_private/_route/_internal/trending'
      path: '/trending'
      fullPath: '/trending'
      preLoaderRoute: typeof PrivateRouteInternalTrendingRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/teams/$teamId': {
      id: '/_private/_route/teams/$teamId'
      path: '/teams/$teamId'
      fullPath: '/teams/$teamId'
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdRouteImport
      parentRoute: typeof PrivateRouteRouteImport
    }
    '/_private/_route/users/$userId': {
      id: '/_private/_route/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof PrivateRouteUsersUserIdRouteImport
      parentRoute: typeof PrivateRouteRouteImport
    }
    '/_layoutAuth/_guest/email-response/': {
      id: '/_layoutAuth/_guest/email-response/'
      path: '/email-response'
      fullPath: '/email-response'
      preLoaderRoute: typeof LayoutAuthGuestEmailResponseIndexRouteImport
      parentRoute: typeof LayoutAuthGuestRouteImport
    }
    '/_layoutAuth/_guest/join/': {
      id: '/_layoutAuth/_guest/join/'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof LayoutAuthGuestJoinIndexRouteImport
      parentRoute: typeof LayoutAuthGuestRouteImport
    }
    '/_layoutAuth/_guest/login/': {
      id: '/_layoutAuth/_guest/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LayoutAuthGuestLoginIndexRouteImport
      parentRoute: typeof LayoutAuthGuestRouteImport
    }
    '/_private/_auth/signup/': {
      id: '/_private/_auth/signup/'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof PrivateAuthSignupIndexRouteImport
      parentRoute: typeof PrivateAuthLazyImport
    }
    '/_private/_route/profile/': {
      id: '/_private/_route/profile/'
      path: '/'
      fullPath: '/profile/'
      preLoaderRoute: typeof PrivateRouteProfileIndexRouteImport
      parentRoute: typeof PrivateRouteProfileRouteImport
    }
    '/_private/_route/users/': {
      id: '/_private/_route/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof PrivateRouteUsersIndexRouteImport
      parentRoute: typeof PrivateRouteRouteImport
    }
    '/_private/teams/$teamId/': {
      id: '/_private/teams/$teamId/'
      path: '/teams/$teamId'
      fullPath: '/teams/$teamId'
      preLoaderRoute: typeof PrivateTeamsTeamIdIndexRouteImport
      parentRoute: typeof PrivateRouteImport
    }
    '/_private/_route/_internal/pipelines/': {
      id: '/_private/_route/_internal/pipelines/'
      path: '/'
      fullPath: '/pipelines/'
      preLoaderRoute: typeof PrivateRouteInternalPipelinesIndexRouteImport
      parentRoute: typeof PrivateRouteInternalPipelinesRouteImport
    }
    '/_private/_route/_internal/candidates/$candidateId': {
      id: '/_private/_route/_internal/candidates/$candidateId'
      path: '/candidates/$candidateId'
      fullPath: '/candidates/$candidateId'
      preLoaderRoute: typeof PrivateRouteInternalCandidatesCandidateIdRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/_internal/events/$eventId': {
      id: '/_private/_route/_internal/events/$eventId'
      path: '/$eventId'
      fullPath: '/events/$eventId'
      preLoaderRoute: typeof PrivateRouteInternalEventsEventIdRouteImport
      parentRoute: typeof PrivateRouteInternalEventsRouteImport
    }
    '/_private/_route/_internal/people/$identityId': {
      id: '/_private/_route/_internal/people/$identityId'
      path: '/people/$identityId'
      fullPath: '/people/$identityId'
      preLoaderRoute: typeof PrivateRouteInternalPeopleIdentityIdRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/_internal/pipelines/new': {
      id: '/_private/_route/_internal/pipelines/new'
      path: '/pipelines/new'
      fullPath: '/pipelines/new'
      preLoaderRoute: typeof PrivateRouteInternalPipelinesNewRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/teams/$teamId/candidates': {
      id: '/_private/_route/teams/$teamId/candidates'
      path: '/candidates'
      fullPath: '/teams/$teamId/candidates'
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdCandidatesRouteImport
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteImport
    }
    '/_private/_route/teams/$teamId/network': {
      id: '/_private/_route/teams/$teamId/network'
      path: '/network'
      fullPath: '/teams/$teamId/network'
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdNetworkRouteImport
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteImport
    }
    '/_private/_route/users/$userId/people': {
      id: '/_private/_route/users/$userId/people'
      path: '/people'
      fullPath: '/users/$userId/people'
      preLoaderRoute: typeof PrivateRouteUsersUserIdPeopleRouteImport
      parentRoute: typeof PrivateRouteUsersUserIdRouteImport
    }
    '/_private/_route/users/$userId/trending': {
      id: '/_private/_route/users/$userId/trending'
      path: '/trending'
      fullPath: '/users/$userId/trending'
      preLoaderRoute: typeof PrivateRouteUsersUserIdTrendingRouteImport
      parentRoute: typeof PrivateRouteUsersUserIdRouteImport
    }
    '/_private/_route/teams/$teamId/trending': {
      id: '/_private/_route/teams/$teamId/trending'
      path: '/trending'
      fullPath: '/teams/$teamId/trending'
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdTrendingLazyImport
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteImport
    }
    '/_private/_route/_internal/companies/': {
      id: '/_private/_route/_internal/companies/'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof PrivateRouteInternalCompaniesIndexRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/_internal/events/': {
      id: '/_private/_route/_internal/events/'
      path: '/'
      fullPath: '/events/'
      preLoaderRoute: typeof PrivateRouteInternalEventsIndexRouteImport
      parentRoute: typeof PrivateRouteInternalEventsRouteImport
    }
    '/_private/_route/_internal/experiments/': {
      id: '/_private/_route/_internal/experiments/'
      path: '/experiments'
      fullPath: '/experiments'
      preLoaderRoute: typeof PrivateRouteInternalExperimentsIndexRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/_internal/home/': {
      id: '/_private/_route/_internal/home/'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof PrivateRouteInternalHomeIndexRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/_internal/introductions/': {
      id: '/_private/_route/_internal/introductions/'
      path: '/introductions'
      fullPath: '/introductions'
      preLoaderRoute: typeof PrivateRouteInternalIntroductionsIndexRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/_internal/peers/': {
      id: '/_private/_route/_internal/peers/'
      path: '/peers'
      fullPath: '/peers'
      preLoaderRoute: typeof PrivateRouteInternalPeersIndexRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/_internal/people/': {
      id: '/_private/_route/_internal/people/'
      path: '/people'
      fullPath: '/people'
      preLoaderRoute: typeof PrivateRouteInternalPeopleIndexRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/_internal/performance/': {
      id: '/_private/_route/_internal/performance/'
      path: '/performance'
      fullPath: '/performance'
      preLoaderRoute: typeof PrivateRouteInternalPerformanceIndexRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/_internal/pipeline-submissions/': {
      id: '/_private/_route/_internal/pipeline-submissions/'
      path: '/pipeline-submissions'
      fullPath: '/pipeline-submissions'
      preLoaderRoute: typeof PrivateRouteInternalPipelineSubmissionsIndexRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/_internal/search-submissions/': {
      id: '/_private/_route/_internal/search-submissions/'
      path: '/search-submissions'
      fullPath: '/search-submissions'
      preLoaderRoute: typeof PrivateRouteInternalSearchSubmissionsIndexRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/_internal/searches/': {
      id: '/_private/_route/_internal/searches/'
      path: '/searches'
      fullPath: '/searches'
      preLoaderRoute: typeof PrivateRouteInternalSearchesIndexRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/_internal/tasks/': {
      id: '/_private/_route/_internal/tasks/'
      path: '/'
      fullPath: '/tasks/'
      preLoaderRoute: typeof PrivateRouteInternalTasksIndexRouteImport
      parentRoute: typeof PrivateRouteInternalTasksRouteImport
    }
    '/_private/_route/_internal/tools/': {
      id: '/_private/_route/_internal/tools/'
      path: '/tools'
      fullPath: '/tools'
      preLoaderRoute: typeof PrivateRouteInternalToolsIndexRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/_internal/trending/': {
      id: '/_private/_route/_internal/trending/'
      path: '/'
      fullPath: '/trending/'
      preLoaderRoute: typeof PrivateRouteInternalTrendingIndexRouteImport
      parentRoute: typeof PrivateRouteInternalTrendingRouteImport
    }
    '/_private/_route/profile/teams/': {
      id: '/_private/_route/profile/teams/'
      path: '/teams'
      fullPath: '/profile/teams'
      preLoaderRoute: typeof PrivateRouteProfileTeamsIndexRouteImport
      parentRoute: typeof PrivateRouteProfileRouteImport
    }
    '/_private/_route/users/$userId/': {
      id: '/_private/_route/users/$userId/'
      path: '/'
      fullPath: '/users/$userId/'
      preLoaderRoute: typeof PrivateRouteUsersUserIdIndexRouteImport
      parentRoute: typeof PrivateRouteUsersUserIdRouteImport
    }
    '/_private/_route/users/new/': {
      id: '/_private/_route/users/new/'
      path: '/users/new'
      fullPath: '/users/new'
      preLoaderRoute: typeof PrivateRouteUsersNewIndexRouteImport
      parentRoute: typeof PrivateRouteRouteImport
    }
    '/_private/_route/_internal/admin/users/$userId': {
      id: '/_private/_route/_internal/admin/users/$userId'
      path: '/users/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof PrivateRouteInternalAdminUsersUserIdRouteImport
      parentRoute: typeof PrivateRouteInternalAdminRouteImport
    }
    '/_private/_route/_internal/candidates/$candidateId/tasks': {
      id: '/_private/_route/_internal/candidates/$candidateId/tasks'
      path: '/tasks'
      fullPath: '/candidates/$candidateId/tasks'
      preLoaderRoute: typeof PrivateRouteInternalCandidatesCandidateIdTasksRouteImport
      parentRoute: typeof PrivateRouteInternalCandidatesCandidateIdRouteImport
    }
    '/_private/_route/_internal/events/$eventId/participants': {
      id: '/_private/_route/_internal/events/$eventId/participants'
      path: '/participants'
      fullPath: '/events/$eventId/participants'
      preLoaderRoute: typeof PrivateRouteInternalEventsEventIdParticipantsRouteImport
      parentRoute: typeof PrivateRouteInternalEventsEventIdRouteImport
    }
    '/_private/_route/_internal/events/participants/$participantId': {
      id: '/_private/_route/_internal/events/participants/$participantId'
      path: '/participants/$participantId'
      fullPath: '/events/participants/$participantId'
      preLoaderRoute: typeof PrivateRouteInternalEventsParticipantsParticipantIdRouteImport
      parentRoute: typeof PrivateRouteInternalEventsRouteImport
    }
    '/_private/_route/_internal/people/$identityId/_candidate': {
      id: '/_private/_route/_internal/people/$identityId/_candidate'
      path: ''
      fullPath: '/people/$identityId'
      preLoaderRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateRouteImport
      parentRoute: typeof PrivateRouteInternalPeopleIdentityIdRouteImport
    }
    '/_private/_route/teams/$teamId/candidates/$candidateId': {
      id: '/_private/_route/teams/$teamId/candidates/$candidateId'
      path: '/$candidateId'
      fullPath: '/teams/$teamId/candidates/$candidateId'
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteImport
      parentRoute: typeof PrivateRouteTeamsTeamIdCandidatesRouteImport
    }
    '/_private/_route/teams/$teamId/pipelines/new': {
      id: '/_private/_route/teams/$teamId/pipelines/new'
      path: '/pipelines/new'
      fullPath: '/teams/$teamId/pipelines/new'
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdPipelinesNewRouteImport
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteImport
    }
    '/_private/_route/users/$userId/people/$candidateId': {
      id: '/_private/_route/users/$userId/people/$candidateId'
      path: '/$candidateId'
      fullPath: '/users/$userId/people/$candidateId'
      preLoaderRoute: typeof PrivateRouteUsersUserIdPeopleCandidateIdRouteImport
      parentRoute: typeof PrivateRouteUsersUserIdPeopleRouteImport
    }
    '/_private/_route/users/$userId/pipelines/new': {
      id: '/_private/_route/users/$userId/pipelines/new'
      path: '/pipelines/new'
      fullPath: '/users/$userId/pipelines/new'
      preLoaderRoute: typeof PrivateRouteUsersUserIdPipelinesNewRouteImport
      parentRoute: typeof PrivateRouteUsersUserIdRouteImport
    }
    '/_private/_route/teams/$teamId/pipelines/$pipelineId': {
      id: '/_private/_route/teams/$teamId/pipelines/$pipelineId'
      path: '/pipelines/$pipelineId'
      fullPath: '/teams/$teamId/pipelines/$pipelineId'
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdLazyImport
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteImport
    }
    '/_private/_route/_internal/admin/users/': {
      id: '/_private/_route/_internal/admin/users/'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof PrivateRouteInternalAdminUsersIndexRouteImport
      parentRoute: typeof PrivateRouteInternalAdminRouteImport
    }
    '/_private/_route/_internal/candidates/$candidateId/': {
      id: '/_private/_route/_internal/candidates/$candidateId/'
      path: '/'
      fullPath: '/candidates/$candidateId/'
      preLoaderRoute: typeof PrivateRouteInternalCandidatesCandidateIdIndexRouteImport
      parentRoute: typeof PrivateRouteInternalCandidatesCandidateIdRouteImport
    }
    '/_private/_route/_internal/candidates/new/': {
      id: '/_private/_route/_internal/candidates/new/'
      path: '/candidates/new'
      fullPath: '/candidates/new'
      preLoaderRoute: typeof PrivateRouteInternalCandidatesNewIndexRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/_internal/events/$eventId/': {
      id: '/_private/_route/_internal/events/$eventId/'
      path: '/'
      fullPath: '/events/$eventId/'
      preLoaderRoute: typeof PrivateRouteInternalEventsEventIdIndexRouteImport
      parentRoute: typeof PrivateRouteInternalEventsEventIdRouteImport
    }
    '/_private/_route/_internal/events/events/': {
      id: '/_private/_route/_internal/events/events/'
      path: '/events'
      fullPath: '/events/events'
      preLoaderRoute: typeof PrivateRouteInternalEventsEventsIndexRouteImport
      parentRoute: typeof PrivateRouteInternalEventsRouteImport
    }
    '/_private/_route/_internal/events/new/': {
      id: '/_private/_route/_internal/events/new/'
      path: '/new'
      fullPath: '/events/new'
      preLoaderRoute: typeof PrivateRouteInternalEventsNewIndexRouteImport
      parentRoute: typeof PrivateRouteInternalEventsRouteImport
    }
    '/_private/_route/_internal/events/participants/': {
      id: '/_private/_route/_internal/events/participants/'
      path: '/participants'
      fullPath: '/events/participants'
      preLoaderRoute: typeof PrivateRouteInternalEventsParticipantsIndexRouteImport
      parentRoute: typeof PrivateRouteInternalEventsRouteImport
    }
    '/_private/_route/_internal/events/settings/': {
      id: '/_private/_route/_internal/events/settings/'
      path: '/settings'
      fullPath: '/events/settings'
      preLoaderRoute: typeof PrivateRouteInternalEventsSettingsIndexRouteImport
      parentRoute: typeof PrivateRouteInternalEventsRouteImport
    }
    '/_private/_route/_internal/introduction-submissions/$submissionId/': {
      id: '/_private/_route/_internal/introduction-submissions/$submissionId/'
      path: '/introduction-submissions/$submissionId'
      fullPath: '/introduction-submissions/$submissionId'
      preLoaderRoute: typeof PrivateRouteInternalIntroductionSubmissionsSubmissionIdIndexRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/_internal/peers/new/': {
      id: '/_private/_route/_internal/peers/new/'
      path: '/peers/new'
      fullPath: '/peers/new'
      preLoaderRoute: typeof PrivateRouteInternalPeersNewIndexRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/_internal/people/$identityId/': {
      id: '/_private/_route/_internal/people/$identityId/'
      path: '/'
      fullPath: '/people/$identityId/'
      preLoaderRoute: typeof PrivateRouteInternalPeopleIdentityIdIndexRouteImport
      parentRoute: typeof PrivateRouteInternalPeopleIdentityIdRouteImport
    }
    '/_private/_route/_internal/pipeline-submissions/$submissionId/': {
      id: '/_private/_route/_internal/pipeline-submissions/$submissionId/'
      path: '/pipeline-submissions/$submissionId'
      fullPath: '/pipeline-submissions/$submissionId'
      preLoaderRoute: typeof PrivateRouteInternalPipelineSubmissionsSubmissionIdIndexRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/_internal/tasks/executive-services/': {
      id: '/_private/_route/_internal/tasks/executive-services/'
      path: '/executive-services'
      fullPath: '/tasks/executive-services'
      preLoaderRoute: typeof PrivateRouteInternalTasksExecutiveServicesIndexRouteImport
      parentRoute: typeof PrivateRouteInternalTasksRouteImport
    }
    '/_private/_route/_internal/tasks/me/': {
      id: '/_private/_route/_internal/tasks/me/'
      path: '/me'
      fullPath: '/tasks/me'
      preLoaderRoute: typeof PrivateRouteInternalTasksMeIndexRouteImport
      parentRoute: typeof PrivateRouteInternalTasksRouteImport
    }
    '/_private/_route/_internal/tools/ai-candidate-discovery/': {
      id: '/_private/_route/_internal/tools/ai-candidate-discovery/'
      path: '/tools/ai-candidate-discovery'
      fullPath: '/tools/ai-candidate-discovery'
      preLoaderRoute: typeof PrivateRouteInternalToolsAiCandidateDiscoveryIndexRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/_internal/tools/email-templates/': {
      id: '/_private/_route/_internal/tools/email-templates/'
      path: '/tools/email-templates'
      fullPath: '/tools/email-templates'
      preLoaderRoute: typeof PrivateRouteInternalToolsEmailTemplatesIndexRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/_internal/tools/market-searches/': {
      id: '/_private/_route/_internal/tools/market-searches/'
      path: '/tools/market-searches'
      fullPath: '/tools/market-searches'
      preLoaderRoute: typeof PrivateRouteInternalToolsMarketSearchesIndexRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/_internal/tools/merge-people/': {
      id: '/_private/_route/_internal/tools/merge-people/'
      path: '/tools/merge-people'
      fullPath: '/tools/merge-people'
      preLoaderRoute: typeof PrivateRouteInternalToolsMergePeopleIndexRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/_internal/tools/move-team/': {
      id: '/_private/_route/_internal/tools/move-team/'
      path: '/tools/move-team'
      fullPath: '/tools/move-team'
      preLoaderRoute: typeof PrivateRouteInternalToolsMoveTeamIndexRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/_internal/tools/pathway-activity-defaults/': {
      id: '/_private/_route/_internal/tools/pathway-activity-defaults/'
      path: '/tools/pathway-activity-defaults'
      fullPath: '/tools/pathway-activity-defaults'
      preLoaderRoute: typeof PrivateRouteInternalToolsPathwayActivityDefaultsIndexRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/_internal/trending/$submissionId/': {
      id: '/_private/_route/_internal/trending/$submissionId/'
      path: '/$submissionId'
      fullPath: '/trending/$submissionId'
      preLoaderRoute: typeof PrivateRouteInternalTrendingSubmissionIdIndexRouteImport
      parentRoute: typeof PrivateRouteInternalTrendingRouteImport
    }
    '/_private/_route/_internal/trending/campaigns/': {
      id: '/_private/_route/_internal/trending/campaigns/'
      path: '/campaigns'
      fullPath: '/trending/campaigns'
      preLoaderRoute: typeof PrivateRouteInternalTrendingCampaignsIndexRouteImport
      parentRoute: typeof PrivateRouteInternalTrendingRouteImport
    }
    '/_private/_route/_internal/trending/new/': {
      id: '/_private/_route/_internal/trending/new/'
      path: '/new'
      fullPath: '/trending/new'
      preLoaderRoute: typeof PrivateRouteInternalTrendingNewIndexRouteImport
      parentRoute: typeof PrivateRouteInternalTrendingRouteImport
    }
    '/_private/_route/_internal/trending/people/': {
      id: '/_private/_route/_internal/trending/people/'
      path: '/people'
      fullPath: '/trending/people'
      preLoaderRoute: typeof PrivateRouteInternalTrendingPeopleIndexRouteImport
      parentRoute: typeof PrivateRouteInternalTrendingRouteImport
    }
    '/_private/_route/teams/$teamId/home/': {
      id: '/_private/_route/teams/$teamId/home/'
      path: '/home'
      fullPath: '/teams/$teamId/home'
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdHomeIndexRouteImport
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteImport
    }
    '/_private/_route/teams/$teamId/introductions/': {
      id: '/_private/_route/teams/$teamId/introductions/'
      path: '/introductions'
      fullPath: '/teams/$teamId/introductions'
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdIntroductionsIndexRouteImport
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteImport
    }
    '/_private/_route/teams/$teamId/pipelines/': {
      id: '/_private/_route/teams/$teamId/pipelines/'
      path: '/pipelines'
      fullPath: '/teams/$teamId/pipelines'
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdPipelinesIndexRouteImport
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteImport
    }
    '/_private/_route/teams/$teamId/searches/': {
      id: '/_private/_route/teams/$teamId/searches/'
      path: '/searches'
      fullPath: '/teams/$teamId/searches'
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdSearchesIndexRouteImport
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteImport
    }
    '/_private/_route/teams/$teamId/settings/': {
      id: '/_private/_route/teams/$teamId/settings/'
      path: '/settings'
      fullPath: '/teams/$teamId/settings'
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdSettingsIndexRouteImport
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteImport
    }
    '/_private/_route/users/$userId/events/': {
      id: '/_private/_route/users/$userId/events/'
      path: '/events'
      fullPath: '/users/$userId/events'
      preLoaderRoute: typeof PrivateRouteUsersUserIdEventsIndexRouteImport
      parentRoute: typeof PrivateRouteUsersUserIdRouteImport
    }
    '/_private/_route/users/$userId/pipelines/': {
      id: '/_private/_route/users/$userId/pipelines/'
      path: '/pipelines'
      fullPath: '/users/$userId/pipelines'
      preLoaderRoute: typeof PrivateRouteUsersUserIdPipelinesIndexRouteImport
      parentRoute: typeof PrivateRouteUsersUserIdRouteImport
    }
    '/_private/_route/users/$userId/settings/': {
      id: '/_private/_route/users/$userId/settings/'
      path: '/settings'
      fullPath: '/users/$userId/settings'
      preLoaderRoute: typeof PrivateRouteUsersUserIdSettingsIndexRouteImport
      parentRoute: typeof PrivateRouteUsersUserIdRouteImport
    }
    '/_private/_route/teams/$teamId/trending/': {
      id: '/_private/_route/teams/$teamId/trending/'
      path: '/'
      fullPath: '/teams/$teamId/trending/'
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdTrendingIndexImport
      parentRoute: typeof PrivateRouteTeamsTeamIdTrendingLazyImport
    }
    '/_private/_route/users/$userId/trending/': {
      id: '/_private/_route/users/$userId/trending/'
      path: '/'
      fullPath: '/users/$userId/trending/'
      preLoaderRoute: typeof PrivateRouteUsersUserIdTrendingIndexImport
      parentRoute: typeof PrivateRouteUsersUserIdTrendingRouteImport
    }
    '/_private/_route/_internal/people/$identityId/_candidate/tasks': {
      id: '/_private/_route/_internal/people/$identityId/_candidate/tasks'
      path: '/tasks'
      fullPath: '/people/$identityId/tasks'
      preLoaderRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateTasksRouteImport
      parentRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateRouteImport
    }
    '/_private/_route/teams/$teamId/candidates/$candidateId/$tabId': {
      id: '/_private/_route/teams/$teamId/candidates/$candidateId/$tabId'
      path: '/$tabId'
      fullPath: '/teams/$teamId/candidates/$candidateId/$tabId'
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdTabIdRouteImport
      parentRoute: typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteImport
    }
    '/_private/_route/teams/$teamId/pipelines/$pipelineId/edit': {
      id: '/_private/_route/teams/$teamId/pipelines/$pipelineId/edit'
      path: '/pipelines/$pipelineId/edit'
      fullPath: '/teams/$teamId/pipelines/$pipelineId/edit'
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdEditRouteImport
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteImport
    }
    '/_private/_route/users/$userId/pipelines/$pipelineId/edit': {
      id: '/_private/_route/users/$userId/pipelines/$pipelineId/edit'
      path: '/pipelines/$pipelineId/edit'
      fullPath: '/users/$userId/pipelines/$pipelineId/edit'
      preLoaderRoute: typeof PrivateRouteUsersUserIdPipelinesPipelineIdEditRouteImport
      parentRoute: typeof PrivateRouteUsersUserIdRouteImport
    }
    '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal': {
      id: '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal'
      path: ''
      fullPath: '/teams/$teamId/pipelines/$pipelineId'
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalLazyImport
      parentRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdLazyImport
    }
    '/_private/_route/_internal/admin/users/new/': {
      id: '/_private/_route/_internal/admin/users/new/'
      path: '/users/new'
      fullPath: '/admin/users/new'
      preLoaderRoute: typeof PrivateRouteInternalAdminUsersNewIndexRouteImport
      parentRoute: typeof PrivateRouteInternalAdminRouteImport
    }
    '/_private/_route/_internal/candidates/$candidateId/about/': {
      id: '/_private/_route/_internal/candidates/$candidateId/about/'
      path: '/about'
      fullPath: '/candidates/$candidateId/about'
      preLoaderRoute: typeof PrivateRouteInternalCandidatesCandidateIdAboutIndexRouteImport
      parentRoute: typeof PrivateRouteInternalCandidatesCandidateIdRouteImport
    }
    '/_private/_route/_internal/candidates/$candidateId/accounts/': {
      id: '/_private/_route/_internal/candidates/$candidateId/accounts/'
      path: '/accounts'
      fullPath: '/candidates/$candidateId/accounts'
      preLoaderRoute: typeof PrivateRouteInternalCandidatesCandidateIdAccountsIndexRouteImport
      parentRoute: typeof PrivateRouteInternalCandidatesCandidateIdRouteImport
    }
    '/_private/_route/_internal/candidates/$candidateId/compare/': {
      id: '/_private/_route/_internal/candidates/$candidateId/compare/'
      path: '/compare'
      fullPath: '/candidates/$candidateId/compare'
      preLoaderRoute: typeof PrivateRouteInternalCandidatesCandidateIdCompareIndexRouteImport
      parentRoute: typeof PrivateRouteInternalCandidatesCandidateIdRouteImport
    }
    '/_private/_route/_internal/candidates/$candidateId/feedback/': {
      id: '/_private/_route/_internal/candidates/$candidateId/feedback/'
      path: '/feedback'
      fullPath: '/candidates/$candidateId/feedback'
      preLoaderRoute: typeof PrivateRouteInternalCandidatesCandidateIdFeedbackIndexRouteImport
      parentRoute: typeof PrivateRouteInternalCandidatesCandidateIdRouteImport
    }
    '/_private/_route/_internal/candidates/$candidateId/performance/': {
      id: '/_private/_route/_internal/candidates/$candidateId/performance/'
      path: '/performance'
      fullPath: '/candidates/$candidateId/performance'
      preLoaderRoute: typeof PrivateRouteInternalCandidatesCandidateIdPerformanceIndexRouteImport
      parentRoute: typeof PrivateRouteInternalCandidatesCandidateIdRouteImport
    }
    '/_private/_route/_internal/candidates/$candidateId/profile/': {
      id: '/_private/_route/_internal/candidates/$candidateId/profile/'
      path: '/profile'
      fullPath: '/candidates/$candidateId/profile'
      preLoaderRoute: typeof PrivateRouteInternalCandidatesCandidateIdProfileIndexRouteImport
      parentRoute: typeof PrivateRouteInternalCandidatesCandidateIdRouteImport
    }
    '/_private/_route/_internal/candidates/$candidateId/recommendations/': {
      id: '/_private/_route/_internal/candidates/$candidateId/recommendations/'
      path: '/recommendations'
      fullPath: '/candidates/$candidateId/recommendations'
      preLoaderRoute: typeof PrivateRouteInternalCandidatesCandidateIdRecommendationsIndexRouteImport
      parentRoute: typeof PrivateRouteInternalCandidatesCandidateIdRouteImport
    }
    '/_private/_route/_internal/candidates/$candidateId/suggested-pipelines/': {
      id: '/_private/_route/_internal/candidates/$candidateId/suggested-pipelines/'
      path: '/suggested-pipelines'
      fullPath: '/candidates/$candidateId/suggested-pipelines'
      preLoaderRoute: typeof PrivateRouteInternalCandidatesCandidateIdSuggestedPipelinesIndexRouteImport
      parentRoute: typeof PrivateRouteInternalCandidatesCandidateIdRouteImport
    }
    '/_private/_route/_internal/companies/$companyId/people/': {
      id: '/_private/_route/_internal/companies/$companyId/people/'
      path: '/companies/$companyId/people'
      fullPath: '/companies/$companyId/people'
      preLoaderRoute: typeof PrivateRouteInternalCompaniesCompanyIdPeopleIndexRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/_internal/companies/$companyId/settings/': {
      id: '/_private/_route/_internal/companies/$companyId/settings/'
      path: '/companies/$companyId/settings'
      fullPath: '/companies/$companyId/settings'
      preLoaderRoute: typeof PrivateRouteInternalCompaniesCompanyIdSettingsIndexRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/_internal/events/$eventId/details/': {
      id: '/_private/_route/_internal/events/$eventId/details/'
      path: '/details'
      fullPath: '/events/$eventId/details'
      preLoaderRoute: typeof PrivateRouteInternalEventsEventIdDetailsIndexRouteImport
      parentRoute: typeof PrivateRouteInternalEventsEventIdRouteImport
    }
    '/_private/_route/_internal/events/$eventId/email-settings/': {
      id: '/_private/_route/_internal/events/$eventId/email-settings/'
      path: '/email-settings'
      fullPath: '/events/$eventId/email-settings'
      preLoaderRoute: typeof PrivateRouteInternalEventsEventIdEmailSettingsIndexRouteImport
      parentRoute: typeof PrivateRouteInternalEventsEventIdRouteImport
    }
    '/_private/_route/_internal/events/$eventId/emails/': {
      id: '/_private/_route/_internal/events/$eventId/emails/'
      path: '/emails'
      fullPath: '/events/$eventId/emails'
      preLoaderRoute: typeof PrivateRouteInternalEventsEventIdEmailsIndexRouteImport
      parentRoute: typeof PrivateRouteInternalEventsEventIdRouteImport
    }
    '/_private/_route/_internal/events/participants/$participantId/': {
      id: '/_private/_route/_internal/events/participants/$participantId/'
      path: '/'
      fullPath: '/events/participants/$participantId/'
      preLoaderRoute: typeof PrivateRouteInternalEventsParticipantsParticipantIdIndexRouteImport
      parentRoute: typeof PrivateRouteInternalEventsParticipantsParticipantIdRouteImport
    }
    '/_private/_route/_internal/people/$identityId/accounts/': {
      id: '/_private/_route/_internal/people/$identityId/accounts/'
      path: '/accounts'
      fullPath: '/people/$identityId/accounts'
      preLoaderRoute: typeof PrivateRouteInternalPeopleIdentityIdAccountsIndexRouteImport
      parentRoute: typeof PrivateRouteInternalPeopleIdentityIdRouteImport
    }
    '/_private/_route/_internal/people/$identityId/emails/': {
      id: '/_private/_route/_internal/people/$identityId/emails/'
      path: '/emails'
      fullPath: '/people/$identityId/emails'
      preLoaderRoute: typeof PrivateRouteInternalPeopleIdentityIdEmailsIndexRouteImport
      parentRoute: typeof PrivateRouteInternalPeopleIdentityIdRouteImport
    }
    '/_private/_route/_internal/trending/$submissionId/edit/': {
      id: '/_private/_route/_internal/trending/$submissionId/edit/'
      path: '/$submissionId/edit'
      fullPath: '/trending/$submissionId/edit'
      preLoaderRoute: typeof PrivateRouteInternalTrendingSubmissionIdEditIndexRouteImport
      parentRoute: typeof PrivateRouteInternalTrendingRouteImport
    }
    '/_private/_route/teams/$teamId/candidates/$candidateId/': {
      id: '/_private/_route/teams/$teamId/candidates/$candidateId/'
      path: '/'
      fullPath: '/teams/$teamId/candidates/$candidateId/'
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdIndexRouteImport
      parentRoute: typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteImport
    }
    '/_private/_route/teams/$teamId/introductions/$candidateId/': {
      id: '/_private/_route/teams/$teamId/introductions/$candidateId/'
      path: '/introductions/$candidateId'
      fullPath: '/teams/$teamId/introductions/$candidateId'
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdIntroductionsCandidateIdIndexRouteImport
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteImport
    }
    '/_private/_route/teams/$teamId/searches/$searchId/': {
      id: '/_private/_route/teams/$teamId/searches/$searchId/'
      path: '/searches/$searchId'
      fullPath: '/teams/$teamId/searches/$searchId'
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdSearchesSearchIdIndexRouteImport
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteImport
    }
    '/_private/_route/teams/$teamId/trending/$recommendationId/': {
      id: '/_private/_route/teams/$teamId/trending/$recommendationId/'
      path: '/$recommendationId'
      fullPath: '/teams/$teamId/trending/$recommendationId'
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdTrendingRecommendationIdIndexRouteImport
      parentRoute: typeof PrivateRouteTeamsTeamIdTrendingLazyImport
    }
    '/_private/_route/users/$userId/events/$eventId/': {
      id: '/_private/_route/users/$userId/events/$eventId/'
      path: '/events/$eventId'
      fullPath: '/users/$userId/events/$eventId'
      preLoaderRoute: typeof PrivateRouteUsersUserIdEventsEventIdIndexRouteImport
      parentRoute: typeof PrivateRouteUsersUserIdRouteImport
    }
    '/_private/_route/users/$userId/pipelines/$pipelineId/': {
      id: '/_private/_route/users/$userId/pipelines/$pipelineId/'
      path: '/pipelines/$pipelineId'
      fullPath: '/users/$userId/pipelines/$pipelineId'
      preLoaderRoute: typeof PrivateRouteUsersUserIdPipelinesPipelineIdIndexRouteImport
      parentRoute: typeof PrivateRouteUsersUserIdRouteImport
    }
    '/_private/_route/users/$userId/trending/$recommendationId/': {
      id: '/_private/_route/users/$userId/trending/$recommendationId/'
      path: '/$recommendationId'
      fullPath: '/users/$userId/trending/$recommendationId'
      preLoaderRoute: typeof PrivateRouteUsersUserIdTrendingRecommendationIdIndexRouteImport
      parentRoute: typeof PrivateRouteUsersUserIdTrendingRouteImport
    }
    '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/': {
      id: '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/'
      path: '/'
      fullPath: '/teams/$teamId/pipelines/$pipelineId/'
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalIndexRouteImport
      parentRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalLazyImport
    }
    '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations': {
      id: '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations'
      path: '/recommendations'
      fullPath: '/teams/$teamId/pipelines/$pipelineId/recommendations'
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRouteImport
      parentRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalLazyImport
    }
    '/_private/_route/teams/$teamId/pipelines/$pipelineId/recommendations/new': {
      id: '/_private/_route/teams/$teamId/pipelines/$pipelineId/recommendations/new'
      path: '/pipelines/$pipelineId/recommendations/new'
      fullPath: '/teams/$teamId/pipelines/$pipelineId/recommendations/new'
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdRecommendationsNewRouteImport
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteImport
    }
    '/_private/_route/users/$userId/pipelines/$pipelineId/recommendations/new': {
      id: '/_private/_route/users/$userId/pipelines/$pipelineId/recommendations/new'
      path: '/pipelines/$pipelineId/recommendations/new'
      fullPath: '/users/$userId/pipelines/$pipelineId/recommendations/new'
      preLoaderRoute: typeof PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsNewRouteImport
      parentRoute: typeof PrivateRouteUsersUserIdRouteImport
    }
    '/_private/_route/_internal/admin/users/$userId/settings/': {
      id: '/_private/_route/_internal/admin/users/$userId/settings/'
      path: '/settings'
      fullPath: '/admin/users/$userId/settings'
      preLoaderRoute: typeof PrivateRouteInternalAdminUsersUserIdSettingsIndexRouteImport
      parentRoute: typeof PrivateRouteInternalAdminUsersUserIdRouteImport
    }
    '/_private/_route/_internal/events/$eventId/participants/new/': {
      id: '/_private/_route/_internal/events/$eventId/participants/new/'
      path: '/new'
      fullPath: '/events/$eventId/participants/new'
      preLoaderRoute: typeof PrivateRouteInternalEventsEventIdParticipantsNewIndexRouteImport
      parentRoute: typeof PrivateRouteInternalEventsEventIdParticipantsRouteImport
    }
    '/_private/_route/_internal/people/$identityId/_candidate/about/': {
      id: '/_private/_route/_internal/people/$identityId/_candidate/about/'
      path: '/about'
      fullPath: '/people/$identityId/about'
      preLoaderRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateAboutIndexRouteImport
      parentRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateRouteImport
    }
    '/_private/_route/_internal/people/$identityId/_candidate/compare/': {
      id: '/_private/_route/_internal/people/$identityId/_candidate/compare/'
      path: '/compare'
      fullPath: '/people/$identityId/compare'
      preLoaderRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateCompareIndexRouteImport
      parentRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateRouteImport
    }
    '/_private/_route/_internal/people/$identityId/_candidate/feedback/': {
      id: '/_private/_route/_internal/people/$identityId/_candidate/feedback/'
      path: '/feedback'
      fullPath: '/people/$identityId/feedback'
      preLoaderRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateFeedbackIndexRouteImport
      parentRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateRouteImport
    }
    '/_private/_route/_internal/people/$identityId/_candidate/performance/': {
      id: '/_private/_route/_internal/people/$identityId/_candidate/performance/'
      path: '/performance'
      fullPath: '/people/$identityId/performance'
      preLoaderRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidatePerformanceIndexRouteImport
      parentRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateRouteImport
    }
    '/_private/_route/_internal/people/$identityId/_candidate/profile/': {
      id: '/_private/_route/_internal/people/$identityId/_candidate/profile/'
      path: '/profile'
      fullPath: '/people/$identityId/profile'
      preLoaderRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateProfileIndexRouteImport
      parentRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateRouteImport
    }
    '/_private/_route/_internal/people/$identityId/_candidate/recommendations/': {
      id: '/_private/_route/_internal/people/$identityId/_candidate/recommendations/'
      path: '/recommendations'
      fullPath: '/people/$identityId/recommendations'
      preLoaderRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateRecommendationsIndexRouteImport
      parentRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateRouteImport
    }
    '/_private/_route/_internal/people/$identityId/_candidate/suggested-pipelines/': {
      id: '/_private/_route/_internal/people/$identityId/_candidate/suggested-pipelines/'
      path: '/suggested-pipelines'
      fullPath: '/people/$identityId/suggested-pipelines'
      preLoaderRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateSuggestedPipelinesIndexRouteImport
      parentRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateRouteImport
    }
    '/_private/_route/teams/$teamId/candidates/$candidateId/activity/': {
      id: '/_private/_route/teams/$teamId/candidates/$candidateId/activity/'
      path: '/activity'
      fullPath: '/teams/$teamId/candidates/$candidateId/activity'
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdActivityIndexRouteImport
      parentRoute: typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteImport
    }
    '/_private/_route/teams/$teamId/candidates/$candidateId/pipelines/': {
      id: '/_private/_route/teams/$teamId/candidates/$candidateId/pipelines/'
      path: '/pipelines'
      fullPath: '/teams/$teamId/candidates/$candidateId/pipelines'
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdPipelinesIndexRouteImport
      parentRoute: typeof PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteImport
    }
    '/_private/_route/_internal/people/$identityId/_candidate/tasks/': {
      id: '/_private/_route/_internal/people/$identityId/_candidate/tasks/'
      path: '/'
      fullPath: '/people/$identityId/tasks/'
      preLoaderRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateTasksIndexLazyImport
      parentRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateTasksRouteImport
    }
    '/_private/_route/_internal/candidates/$candidateId/tasks/goals/$goalId/': {
      id: '/_private/_route/_internal/candidates/$candidateId/tasks/goals/$goalId/'
      path: '/goals/$goalId'
      fullPath: '/candidates/$candidateId/tasks/goals/$goalId'
      preLoaderRoute: typeof PrivateRouteInternalCandidatesCandidateIdTasksGoalsGoalIdIndexRouteImport
      parentRoute: typeof PrivateRouteInternalCandidatesCandidateIdTasksRouteImport
    }
    '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations/': {
      id: '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations/'
      path: '/'
      fullPath: '/teams/$teamId/pipelines/$pipelineId/recommendations/'
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsIndexRouteImport
      parentRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRouteImport
    }
    '/_private/_route/teams/$teamId/pipelines/$pipelineId/introductions/$candidateId/': {
      id: '/_private/_route/teams/$teamId/pipelines/$pipelineId/introductions/$candidateId/'
      path: '/introductions/$candidateId'
      fullPath: '/teams/$teamId/pipelines/$pipelineId/introductions/$candidateId'
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdIntroductionsCandidateIdIndexRouteImport
      parentRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdLazyImport
    }
    '/_private/_route/teams/$teamId/pipelines/$pipelineId/submissions/$submissionId/': {
      id: '/_private/_route/teams/$teamId/pipelines/$pipelineId/submissions/$submissionId/'
      path: '/pipelines/$pipelineId/submissions/$submissionId'
      fullPath: '/teams/$teamId/pipelines/$pipelineId/submissions/$submissionId'
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdSubmissionsSubmissionIdIndexRouteImport
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteImport
    }
    '/_private/_route/teams/$teamId/searches/$searchId/candidates/$candidateId/': {
      id: '/_private/_route/teams/$teamId/searches/$searchId/candidates/$candidateId/'
      path: '/searches/$searchId/candidates/$candidateId'
      fullPath: '/teams/$teamId/searches/$searchId/candidates/$candidateId'
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdSearchesSearchIdCandidatesCandidateIdIndexRouteImport
      parentRoute: typeof PrivateRouteTeamsTeamIdRouteImport
    }
    '/_private/_route/users/$userId/pipelines/$pipelineId/recommendations/$recommendationId/': {
      id: '/_private/_route/users/$userId/pipelines/$pipelineId/recommendations/$recommendationId/'
      path: '/pipelines/$pipelineId/recommendations/$recommendationId'
      fullPath: '/users/$userId/pipelines/$pipelineId/recommendations/$recommendationId'
      preLoaderRoute: typeof PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsRecommendationIdIndexRouteImport
      parentRoute: typeof PrivateRouteUsersUserIdRouteImport
    }
    '/_private/_route/_internal/people/$identityId/_candidate/tasks/goals/$goalId/': {
      id: '/_private/_route/_internal/people/$identityId/_candidate/tasks/goals/$goalId/'
      path: '/goals/$goalId'
      fullPath: '/people/$identityId/tasks/goals/$goalId'
      preLoaderRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateTasksGoalsGoalIdIndexRouteImport
      parentRoute: typeof PrivateRouteInternalPeopleIdentityIdCandidateTasksRouteImport
    }
    '/_private/_route/_internal/teams/$teamId/searches/$searchId/submissions/$submissionId/': {
      id: '/_private/_route/_internal/teams/$teamId/searches/$searchId/submissions/$submissionId/'
      path: '/teams/$teamId/searches/$searchId/submissions/$submissionId'
      fullPath: '/teams/$teamId/searches/$searchId/submissions/$submissionId'
      preLoaderRoute: typeof PrivateRouteInternalTeamsTeamIdSearchesSearchIdSubmissionsSubmissionIdIndexRouteImport
      parentRoute: typeof PrivateRouteInternalRouteImport
    }
    '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations/$recommendationId/': {
      id: '/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations/$recommendationId/'
      path: '/$recommendationId'
      fullPath: '/teams/$teamId/pipelines/$pipelineId/recommendations/$recommendationId'
      preLoaderRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRecommendationIdIndexRouteImport
      parentRoute: typeof PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRouteImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  LayoutAuthRouteRoute: LayoutAuthRouteRoute.addChildren({
    LayoutAuthGuestRouteRoute: LayoutAuthGuestRouteRoute.addChildren({
      LayoutAuthGuestEmailResponseIndexRouteRoute,
      LayoutAuthGuestJoinIndexRouteRoute,
      LayoutAuthGuestLoginIndexRouteRoute,
    }),
    LayoutAuthExecAccessDisabledIndexRouteRoute,
    LayoutAuthLogoutIndexRouteRoute,
    LayoutAuthMaintenanceIndexRouteRoute,
    LayoutAuthUnsupportedAccountIndexRouteRoute,
  }),
  PrivateRouteRoute: PrivateRouteRoute.addChildren({
    PrivateRouteRouteRoute: PrivateRouteRouteRoute.addChildren({
      PrivateRouteSplatRouteRoute,
      PrivateRouteInternalRouteRoute:
        PrivateRouteInternalRouteRoute.addChildren({
          PrivateRouteInternalAdminRouteRoute:
            PrivateRouteInternalAdminRouteRoute.addChildren({
              PrivateRouteInternalAdminUsersUserIdRouteRoute:
                PrivateRouteInternalAdminUsersUserIdRouteRoute.addChildren({
                  PrivateRouteInternalAdminUsersUserIdSettingsIndexRouteRoute,
                }),
              PrivateRouteInternalAdminUsersIndexRouteRoute,
              PrivateRouteInternalAdminUsersNewIndexRouteRoute,
            }),
          PrivateRouteInternalEventsRouteRoute:
            PrivateRouteInternalEventsRouteRoute.addChildren({
              PrivateRouteInternalEventsEventIdRouteRoute:
                PrivateRouteInternalEventsEventIdRouteRoute.addChildren({
                  PrivateRouteInternalEventsEventIdParticipantsRouteRoute:
                    PrivateRouteInternalEventsEventIdParticipantsRouteRoute.addChildren(
                      {
                        PrivateRouteInternalEventsEventIdParticipantsNewIndexRouteRoute,
                      },
                    ),
                  PrivateRouteInternalEventsEventIdIndexRouteRoute,
                  PrivateRouteInternalEventsEventIdDetailsIndexRouteRoute,
                  PrivateRouteInternalEventsEventIdEmailSettingsIndexRouteRoute,
                  PrivateRouteInternalEventsEventIdEmailsIndexRouteRoute,
                }),
              PrivateRouteInternalEventsIndexRouteRoute,
              PrivateRouteInternalEventsParticipantsParticipantIdRouteRoute:
                PrivateRouteInternalEventsParticipantsParticipantIdRouteRoute.addChildren(
                  {
                    PrivateRouteInternalEventsParticipantsParticipantIdIndexRouteRoute,
                  },
                ),
              PrivateRouteInternalEventsEventsIndexRouteRoute,
              PrivateRouteInternalEventsNewIndexRouteRoute,
              PrivateRouteInternalEventsParticipantsIndexRouteRoute,
              PrivateRouteInternalEventsSettingsIndexRouteRoute,
            }),
          PrivateRouteInternalPipelinesRouteRoute:
            PrivateRouteInternalPipelinesRouteRoute.addChildren({
              PrivateRouteInternalPipelinesIndexRouteRoute,
            }),
          PrivateRouteInternalTasksRouteRoute:
            PrivateRouteInternalTasksRouteRoute.addChildren({
              PrivateRouteInternalTasksIndexRouteRoute,
              PrivateRouteInternalTasksExecutiveServicesIndexRouteRoute,
              PrivateRouteInternalTasksMeIndexRouteRoute,
            }),
          PrivateRouteInternalTrendingRouteRoute:
            PrivateRouteInternalTrendingRouteRoute.addChildren({
              PrivateRouteInternalTrendingIndexRouteRoute,
              PrivateRouteInternalTrendingSubmissionIdIndexRouteRoute,
              PrivateRouteInternalTrendingCampaignsIndexRouteRoute,
              PrivateRouteInternalTrendingNewIndexRouteRoute,
              PrivateRouteInternalTrendingPeopleIndexRouteRoute,
              PrivateRouteInternalTrendingSubmissionIdEditIndexRouteRoute,
            }),
          PrivateRouteInternalCandidatesCandidateIdRouteRoute:
            PrivateRouteInternalCandidatesCandidateIdRouteRoute.addChildren({
              PrivateRouteInternalCandidatesCandidateIdTasksRouteRoute:
                PrivateRouteInternalCandidatesCandidateIdTasksRouteRoute.addChildren(
                  {
                    PrivateRouteInternalCandidatesCandidateIdTasksGoalsGoalIdIndexRouteRoute,
                  },
                ),
              PrivateRouteInternalCandidatesCandidateIdIndexRouteRoute,
              PrivateRouteInternalCandidatesCandidateIdAboutIndexRouteRoute,
              PrivateRouteInternalCandidatesCandidateIdAccountsIndexRouteRoute,
              PrivateRouteInternalCandidatesCandidateIdCompareIndexRouteRoute,
              PrivateRouteInternalCandidatesCandidateIdFeedbackIndexRouteRoute,
              PrivateRouteInternalCandidatesCandidateIdPerformanceIndexRouteRoute,
              PrivateRouteInternalCandidatesCandidateIdProfileIndexRouteRoute,
              PrivateRouteInternalCandidatesCandidateIdRecommendationsIndexRouteRoute,
              PrivateRouteInternalCandidatesCandidateIdSuggestedPipelinesIndexRouteRoute,
            }),
          PrivateRouteInternalPeopleIdentityIdRouteRoute:
            PrivateRouteInternalPeopleIdentityIdRouteRoute.addChildren({
              PrivateRouteInternalPeopleIdentityIdCandidateRouteRoute:
                PrivateRouteInternalPeopleIdentityIdCandidateRouteRoute.addChildren(
                  {
                    PrivateRouteInternalPeopleIdentityIdCandidateTasksRouteRoute:
                      PrivateRouteInternalPeopleIdentityIdCandidateTasksRouteRoute.addChildren(
                        {
                          PrivateRouteInternalPeopleIdentityIdCandidateTasksIndexLazyRoute,
                          PrivateRouteInternalPeopleIdentityIdCandidateTasksGoalsGoalIdIndexRouteRoute,
                        },
                      ),
                    PrivateRouteInternalPeopleIdentityIdCandidateAboutIndexRouteRoute,
                    PrivateRouteInternalPeopleIdentityIdCandidateCompareIndexRouteRoute,
                    PrivateRouteInternalPeopleIdentityIdCandidateFeedbackIndexRouteRoute,
                    PrivateRouteInternalPeopleIdentityIdCandidatePerformanceIndexRouteRoute,
                    PrivateRouteInternalPeopleIdentityIdCandidateProfileIndexRouteRoute,
                    PrivateRouteInternalPeopleIdentityIdCandidateRecommendationsIndexRouteRoute,
                    PrivateRouteInternalPeopleIdentityIdCandidateSuggestedPipelinesIndexRouteRoute,
                  },
                ),
              PrivateRouteInternalPeopleIdentityIdIndexRouteRoute,
              PrivateRouteInternalPeopleIdentityIdAccountsIndexRouteRoute,
              PrivateRouteInternalPeopleIdentityIdEmailsIndexRouteRoute,
            }),
          PrivateRouteInternalPipelinesNewRouteRoute,
          PrivateRouteInternalCompaniesIndexRouteRoute,
          PrivateRouteInternalExperimentsIndexRouteRoute,
          PrivateRouteInternalHomeIndexRouteRoute,
          PrivateRouteInternalIntroductionsIndexRouteRoute,
          PrivateRouteInternalPeersIndexRouteRoute,
          PrivateRouteInternalPeopleIndexRouteRoute,
          PrivateRouteInternalPerformanceIndexRouteRoute,
          PrivateRouteInternalPipelineSubmissionsIndexRouteRoute,
          PrivateRouteInternalSearchSubmissionsIndexRouteRoute,
          PrivateRouteInternalSearchesIndexRouteRoute,
          PrivateRouteInternalToolsIndexRouteRoute,
          PrivateRouteInternalCandidatesNewIndexRouteRoute,
          PrivateRouteInternalIntroductionSubmissionsSubmissionIdIndexRouteRoute,
          PrivateRouteInternalPeersNewIndexRouteRoute,
          PrivateRouteInternalPipelineSubmissionsSubmissionIdIndexRouteRoute,
          PrivateRouteInternalToolsAiCandidateDiscoveryIndexRouteRoute,
          PrivateRouteInternalToolsEmailTemplatesIndexRouteRoute,
          PrivateRouteInternalToolsMarketSearchesIndexRouteRoute,
          PrivateRouteInternalToolsMergePeopleIndexRouteRoute,
          PrivateRouteInternalToolsMoveTeamIndexRouteRoute,
          PrivateRouteInternalToolsPathwayActivityDefaultsIndexRouteRoute,
          PrivateRouteInternalCompaniesCompanyIdPeopleIndexRouteRoute,
          PrivateRouteInternalCompaniesCompanyIdSettingsIndexRouteRoute,
          PrivateRouteInternalTeamsTeamIdSearchesSearchIdSubmissionsSubmissionIdIndexRouteRoute,
        }),
      PrivateRouteProfileRouteRoute: PrivateRouteProfileRouteRoute.addChildren({
        PrivateRouteProfileIndexRouteRoute,
        PrivateRouteProfileTeamsIndexRouteRoute,
      }),
      PrivateRouteTeamsTeamIdRouteRoute:
        PrivateRouteTeamsTeamIdRouteRoute.addChildren({
          PrivateRouteTeamsTeamIdCandidatesRouteRoute:
            PrivateRouteTeamsTeamIdCandidatesRouteRoute.addChildren({
              PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteRoute:
                PrivateRouteTeamsTeamIdCandidatesCandidateIdRouteRoute.addChildren(
                  {
                    PrivateRouteTeamsTeamIdCandidatesCandidateIdTabIdRouteRoute,
                    PrivateRouteTeamsTeamIdCandidatesCandidateIdIndexRouteRoute,
                    PrivateRouteTeamsTeamIdCandidatesCandidateIdActivityIndexRouteRoute,
                    PrivateRouteTeamsTeamIdCandidatesCandidateIdPipelinesIndexRouteRoute,
                  },
                ),
            }),
          PrivateRouteTeamsTeamIdNetworkRouteRoute,
          PrivateRouteTeamsTeamIdTrendingLazyRoute:
            PrivateRouteTeamsTeamIdTrendingLazyRoute.addChildren({
              PrivateRouteTeamsTeamIdTrendingIndexRoute,
              PrivateRouteTeamsTeamIdTrendingRecommendationIdIndexRouteRoute,
            }),
          PrivateRouteTeamsTeamIdPipelinesNewRouteRoute,
          PrivateRouteTeamsTeamIdPipelinesPipelineIdLazyRoute:
            PrivateRouteTeamsTeamIdPipelinesPipelineIdLazyRoute.addChildren({
              PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalLazyRoute:
                PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalLazyRoute.addChildren(
                  {
                    PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalIndexRouteRoute,
                    PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRouteRoute:
                      PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRouteRoute.addChildren(
                        {
                          PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsIndexRouteRoute,
                          PrivateRouteTeamsTeamIdPipelinesPipelineIdInternalRecommendationsRecommendationIdIndexRouteRoute,
                        },
                      ),
                  },
                ),
              PrivateRouteTeamsTeamIdPipelinesPipelineIdIntroductionsCandidateIdIndexRouteRoute,
            }),
          PrivateRouteTeamsTeamIdHomeIndexRouteRoute,
          PrivateRouteTeamsTeamIdIntroductionsIndexRouteRoute,
          PrivateRouteTeamsTeamIdPipelinesIndexRouteRoute,
          PrivateRouteTeamsTeamIdSearchesIndexRouteRoute,
          PrivateRouteTeamsTeamIdSettingsIndexRouteRoute,
          PrivateRouteTeamsTeamIdPipelinesPipelineIdEditRouteRoute,
          PrivateRouteTeamsTeamIdIntroductionsCandidateIdIndexRouteRoute,
          PrivateRouteTeamsTeamIdSearchesSearchIdIndexRouteRoute,
          PrivateRouteTeamsTeamIdPipelinesPipelineIdRecommendationsNewRouteRoute,
          PrivateRouteTeamsTeamIdPipelinesPipelineIdSubmissionsSubmissionIdIndexRouteRoute,
          PrivateRouteTeamsTeamIdSearchesSearchIdCandidatesCandidateIdIndexRouteRoute,
        }),
      PrivateRouteUsersUserIdRouteRoute:
        PrivateRouteUsersUserIdRouteRoute.addChildren({
          PrivateRouteUsersUserIdPeopleRouteRoute:
            PrivateRouteUsersUserIdPeopleRouteRoute.addChildren({
              PrivateRouteUsersUserIdPeopleCandidateIdRouteRoute,
            }),
          PrivateRouteUsersUserIdTrendingRouteRoute:
            PrivateRouteUsersUserIdTrendingRouteRoute.addChildren({
              PrivateRouteUsersUserIdTrendingIndexRoute,
              PrivateRouteUsersUserIdTrendingRecommendationIdIndexRouteRoute,
            }),
          PrivateRouteUsersUserIdIndexRouteRoute,
          PrivateRouteUsersUserIdPipelinesNewRouteRoute,
          PrivateRouteUsersUserIdEventsIndexRouteRoute,
          PrivateRouteUsersUserIdPipelinesIndexRouteRoute,
          PrivateRouteUsersUserIdSettingsIndexRouteRoute,
          PrivateRouteUsersUserIdPipelinesPipelineIdEditRouteRoute,
          PrivateRouteUsersUserIdEventsEventIdIndexRouteRoute,
          PrivateRouteUsersUserIdPipelinesPipelineIdIndexRouteRoute,
          PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsNewRouteRoute,
          PrivateRouteUsersUserIdPipelinesPipelineIdRecommendationsRecommendationIdIndexRouteRoute,
        }),
      PrivateRouteUsersIndexRouteRoute,
      PrivateRouteUsersNewIndexRouteRoute,
    }),
    PrivateAuthLazyRoute: PrivateAuthLazyRoute.addChildren({
      PrivateAuthSetPasswordRouteRoute,
      PrivateAuthSignupIndexRouteRoute,
    }),
    PrivateIndexRouteRoute,
    PrivateTeamsIndexRouteRoute,
    PrivateTeamsTeamIdIndexRouteRoute,
  }),
  EventsRouteRoute: EventsRouteRoute.addChildren({ EventsRsvpRouteRoute }),
  RegistrationRouteRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_layoutAuth",
        "/_private",
        "/events",
        "/registration"
      ]
    },
    "/_layoutAuth": {
      "filePath": "_layoutAuth/route.tsx",
      "children": [
        "/_layoutAuth/_guest",
        "/_layoutAuth/exec-access-disabled/",
        "/_layoutAuth/logout/",
        "/_layoutAuth/maintenance/",
        "/_layoutAuth/unsupported-account/"
      ]
    },
    "/_private": {
      "filePath": "_private/route.tsx",
      "children": [
        "/_private/_route",
        "/_private/_auth",
        "/_private/",
        "/_private/teams/",
        "/_private/teams/$teamId/"
      ]
    },
    "/events": {
      "filePath": "events/route.tsx",
      "children": [
        "/events/rsvp"
      ]
    },
    "/registration": {
      "filePath": "registration.route.tsx"
    },
    "/_layoutAuth/_guest": {
      "filePath": "_layoutAuth/_guest/route.tsx",
      "parent": "/_layoutAuth",
      "children": [
        "/_layoutAuth/_guest/email-response/",
        "/_layoutAuth/_guest/join/",
        "/_layoutAuth/_guest/login/"
      ]
    },
    "/_private/_route": {
      "filePath": "_private/_route/route.tsx",
      "parent": "/_private",
      "children": [
        "/_private/_route/$",
        "/_private/_route/_internal",
        "/_private/_route/profile",
        "/_private/_route/teams/$teamId",
        "/_private/_route/users/$userId",
        "/_private/_route/users/",
        "/_private/_route/users/new/"
      ]
    },
    "/events/rsvp": {
      "filePath": "events/rsvp.route.tsx",
      "parent": "/events"
    },
    "/_private/_auth": {
      "filePath": "_private/_auth/lazy.tsx",
      "parent": "/_private",
      "children": [
        "/_private/_auth/set-password",
        "/_private/_auth/signup/"
      ]
    },
    "/_private/": {
      "filePath": "_private/index.route.tsx",
      "parent": "/_private"
    },
    "/_private/_auth/set-password": {
      "filePath": "_private/_auth/set-password.route.tsx",
      "parent": "/_private/_auth"
    },
    "/_private/_route/$": {
      "filePath": "_private/_route/$.route.tsx",
      "parent": "/_private/_route"
    },
    "/_private/_route/_internal": {
      "filePath": "_private/_route/_internal/route.tsx",
      "parent": "/_private/_route",
      "children": [
        "/_private/_route/_internal/admin",
        "/_private/_route/_internal/events",
        "/_private/_route/_internal/pipelines",
        "/_private/_route/_internal/tasks",
        "/_private/_route/_internal/trending",
        "/_private/_route/_internal/candidates/$candidateId",
        "/_private/_route/_internal/people/$identityId",
        "/_private/_route/_internal/pipelines/new",
        "/_private/_route/_internal/companies/",
        "/_private/_route/_internal/experiments/",
        "/_private/_route/_internal/home/",
        "/_private/_route/_internal/introductions/",
        "/_private/_route/_internal/peers/",
        "/_private/_route/_internal/people/",
        "/_private/_route/_internal/performance/",
        "/_private/_route/_internal/pipeline-submissions/",
        "/_private/_route/_internal/search-submissions/",
        "/_private/_route/_internal/searches/",
        "/_private/_route/_internal/tools/",
        "/_private/_route/_internal/candidates/new/",
        "/_private/_route/_internal/introduction-submissions/$submissionId/",
        "/_private/_route/_internal/peers/new/",
        "/_private/_route/_internal/pipeline-submissions/$submissionId/",
        "/_private/_route/_internal/tools/ai-candidate-discovery/",
        "/_private/_route/_internal/tools/email-templates/",
        "/_private/_route/_internal/tools/market-searches/",
        "/_private/_route/_internal/tools/merge-people/",
        "/_private/_route/_internal/tools/move-team/",
        "/_private/_route/_internal/tools/pathway-activity-defaults/",
        "/_private/_route/_internal/companies/$companyId/people/",
        "/_private/_route/_internal/companies/$companyId/settings/",
        "/_private/_route/_internal/teams/$teamId/searches/$searchId/submissions/$submissionId/"
      ]
    },
    "/_private/_route/profile": {
      "filePath": "_private/_route/profile/route.tsx",
      "parent": "/_private/_route",
      "children": [
        "/_private/_route/profile/",
        "/_private/_route/profile/teams/"
      ]
    },
    "/_layoutAuth/exec-access-disabled/": {
      "filePath": "_layoutAuth/exec-access-disabled/index.route.tsx",
      "parent": "/_layoutAuth"
    },
    "/_layoutAuth/logout/": {
      "filePath": "_layoutAuth/logout/index.route.tsx",
      "parent": "/_layoutAuth"
    },
    "/_layoutAuth/maintenance/": {
      "filePath": "_layoutAuth/maintenance/index.route.tsx",
      "parent": "/_layoutAuth"
    },
    "/_layoutAuth/unsupported-account/": {
      "filePath": "_layoutAuth/unsupported-account/index.route.tsx",
      "parent": "/_layoutAuth"
    },
    "/_private/teams/": {
      "filePath": "_private/teams/index.route.tsx",
      "parent": "/_private"
    },
    "/_private/_route/_internal/admin": {
      "filePath": "_private/_route/_internal/admin/route.tsx",
      "parent": "/_private/_route/_internal",
      "children": [
        "/_private/_route/_internal/admin/users/$userId",
        "/_private/_route/_internal/admin/users/",
        "/_private/_route/_internal/admin/users/new/"
      ]
    },
    "/_private/_route/_internal/events": {
      "filePath": "_private/_route/_internal/events/route.tsx",
      "parent": "/_private/_route/_internal",
      "children": [
        "/_private/_route/_internal/events/$eventId",
        "/_private/_route/_internal/events/",
        "/_private/_route/_internal/events/participants/$participantId",
        "/_private/_route/_internal/events/events/",
        "/_private/_route/_internal/events/new/",
        "/_private/_route/_internal/events/participants/",
        "/_private/_route/_internal/events/settings/"
      ]
    },
    "/_private/_route/_internal/pipelines": {
      "filePath": "_private/_route/_internal/pipelines/route.tsx",
      "parent": "/_private/_route/_internal",
      "children": [
        "/_private/_route/_internal/pipelines/"
      ]
    },
    "/_private/_route/_internal/tasks": {
      "filePath": "_private/_route/_internal/tasks/route.tsx",
      "parent": "/_private/_route/_internal",
      "children": [
        "/_private/_route/_internal/tasks/",
        "/_private/_route/_internal/tasks/executive-services/",
        "/_private/_route/_internal/tasks/me/"
      ]
    },
    "/_private/_route/_internal/trending": {
      "filePath": "_private/_route/_internal/trending/route.tsx",
      "parent": "/_private/_route/_internal",
      "children": [
        "/_private/_route/_internal/trending/",
        "/_private/_route/_internal/trending/$submissionId/",
        "/_private/_route/_internal/trending/campaigns/",
        "/_private/_route/_internal/trending/new/",
        "/_private/_route/_internal/trending/people/",
        "/_private/_route/_internal/trending/$submissionId/edit/"
      ]
    },
    "/_private/_route/teams/$teamId": {
      "filePath": "_private/_route/teams/$teamId/route.tsx",
      "parent": "/_private/_route",
      "children": [
        "/_private/_route/teams/$teamId/candidates",
        "/_private/_route/teams/$teamId/network",
        "/_private/_route/teams/$teamId/trending",
        "/_private/_route/teams/$teamId/pipelines/new",
        "/_private/_route/teams/$teamId/pipelines/$pipelineId",
        "/_private/_route/teams/$teamId/home/",
        "/_private/_route/teams/$teamId/introductions/",
        "/_private/_route/teams/$teamId/pipelines/",
        "/_private/_route/teams/$teamId/searches/",
        "/_private/_route/teams/$teamId/settings/",
        "/_private/_route/teams/$teamId/pipelines/$pipelineId/edit",
        "/_private/_route/teams/$teamId/introductions/$candidateId/",
        "/_private/_route/teams/$teamId/searches/$searchId/",
        "/_private/_route/teams/$teamId/pipelines/$pipelineId/recommendations/new",
        "/_private/_route/teams/$teamId/pipelines/$pipelineId/submissions/$submissionId/",
        "/_private/_route/teams/$teamId/searches/$searchId/candidates/$candidateId/"
      ]
    },
    "/_private/_route/users/$userId": {
      "filePath": "_private/_route/users/$userId/route.tsx",
      "parent": "/_private/_route",
      "children": [
        "/_private/_route/users/$userId/people",
        "/_private/_route/users/$userId/trending",
        "/_private/_route/users/$userId/",
        "/_private/_route/users/$userId/pipelines/new",
        "/_private/_route/users/$userId/events/",
        "/_private/_route/users/$userId/pipelines/",
        "/_private/_route/users/$userId/settings/",
        "/_private/_route/users/$userId/pipelines/$pipelineId/edit",
        "/_private/_route/users/$userId/events/$eventId/",
        "/_private/_route/users/$userId/pipelines/$pipelineId/",
        "/_private/_route/users/$userId/pipelines/$pipelineId/recommendations/new",
        "/_private/_route/users/$userId/pipelines/$pipelineId/recommendations/$recommendationId/"
      ]
    },
    "/_layoutAuth/_guest/email-response/": {
      "filePath": "_layoutAuth/_guest/email-response/index.route.tsx",
      "parent": "/_layoutAuth/_guest"
    },
    "/_layoutAuth/_guest/join/": {
      "filePath": "_layoutAuth/_guest/join/index.route.tsx",
      "parent": "/_layoutAuth/_guest"
    },
    "/_layoutAuth/_guest/login/": {
      "filePath": "_layoutAuth/_guest/login/index.route.tsx",
      "parent": "/_layoutAuth/_guest"
    },
    "/_private/_auth/signup/": {
      "filePath": "_private/_auth/signup/index.route.tsx",
      "parent": "/_private/_auth"
    },
    "/_private/_route/profile/": {
      "filePath": "_private/_route/profile/index.route.tsx",
      "parent": "/_private/_route/profile"
    },
    "/_private/_route/users/": {
      "filePath": "_private/_route/users/index.route.tsx",
      "parent": "/_private/_route"
    },
    "/_private/teams/$teamId/": {
      "filePath": "_private/teams/$teamId.index.route.tsx",
      "parent": "/_private"
    },
    "/_private/_route/_internal/pipelines/": {
      "filePath": "_private/_route/_internal/pipelines/index/route.tsx",
      "parent": "/_private/_route/_internal/pipelines"
    },
    "/_private/_route/_internal/candidates/$candidateId": {
      "filePath": "_private/_route/_internal/candidates/$candidateId/route.tsx",
      "parent": "/_private/_route/_internal",
      "children": [
        "/_private/_route/_internal/candidates/$candidateId/tasks",
        "/_private/_route/_internal/candidates/$candidateId/",
        "/_private/_route/_internal/candidates/$candidateId/about/",
        "/_private/_route/_internal/candidates/$candidateId/accounts/",
        "/_private/_route/_internal/candidates/$candidateId/compare/",
        "/_private/_route/_internal/candidates/$candidateId/feedback/",
        "/_private/_route/_internal/candidates/$candidateId/performance/",
        "/_private/_route/_internal/candidates/$candidateId/profile/",
        "/_private/_route/_internal/candidates/$candidateId/recommendations/",
        "/_private/_route/_internal/candidates/$candidateId/suggested-pipelines/"
      ]
    },
    "/_private/_route/_internal/events/$eventId": {
      "filePath": "_private/_route/_internal/events/$eventId/route.tsx",
      "parent": "/_private/_route/_internal/events",
      "children": [
        "/_private/_route/_internal/events/$eventId/participants",
        "/_private/_route/_internal/events/$eventId/",
        "/_private/_route/_internal/events/$eventId/details/",
        "/_private/_route/_internal/events/$eventId/email-settings/",
        "/_private/_route/_internal/events/$eventId/emails/"
      ]
    },
    "/_private/_route/_internal/people/$identityId": {
      "filePath": "_private/_route/_internal/people/$identityId/route.tsx",
      "parent": "/_private/_route/_internal",
      "children": [
        "/_private/_route/_internal/people/$identityId/_candidate",
        "/_private/_route/_internal/people/$identityId/",
        "/_private/_route/_internal/people/$identityId/accounts/",
        "/_private/_route/_internal/people/$identityId/emails/"
      ]
    },
    "/_private/_route/_internal/pipelines/new": {
      "filePath": "_private/_route/_internal/pipelines_/new/route.tsx",
      "parent": "/_private/_route/_internal"
    },
    "/_private/_route/teams/$teamId/candidates": {
      "filePath": "_private/_route/teams/$teamId/candidates/route.tsx",
      "parent": "/_private/_route/teams/$teamId",
      "children": [
        "/_private/_route/teams/$teamId/candidates/$candidateId"
      ]
    },
    "/_private/_route/teams/$teamId/network": {
      "filePath": "_private/_route/teams/$teamId/network/route.tsx",
      "parent": "/_private/_route/teams/$teamId"
    },
    "/_private/_route/users/$userId/people": {
      "filePath": "_private/_route/users/$userId/people/route.tsx",
      "parent": "/_private/_route/users/$userId",
      "children": [
        "/_private/_route/users/$userId/people/$candidateId"
      ]
    },
    "/_private/_route/users/$userId/trending": {
      "filePath": "_private/_route/users/$userId/trending/route.tsx",
      "parent": "/_private/_route/users/$userId",
      "children": [
        "/_private/_route/users/$userId/trending/",
        "/_private/_route/users/$userId/trending/$recommendationId/"
      ]
    },
    "/_private/_route/teams/$teamId/trending": {
      "filePath": "_private/_route/teams/$teamId/trending/lazy.tsx",
      "parent": "/_private/_route/teams/$teamId",
      "children": [
        "/_private/_route/teams/$teamId/trending/",
        "/_private/_route/teams/$teamId/trending/$recommendationId/"
      ]
    },
    "/_private/_route/_internal/companies/": {
      "filePath": "_private/_route/_internal/companies/index.route.tsx",
      "parent": "/_private/_route/_internal"
    },
    "/_private/_route/_internal/events/": {
      "filePath": "_private/_route/_internal/events/index.route.tsx",
      "parent": "/_private/_route/_internal/events"
    },
    "/_private/_route/_internal/experiments/": {
      "filePath": "_private/_route/_internal/experiments/index.route.tsx",
      "parent": "/_private/_route/_internal"
    },
    "/_private/_route/_internal/home/": {
      "filePath": "_private/_route/_internal/home/index.route.tsx",
      "parent": "/_private/_route/_internal"
    },
    "/_private/_route/_internal/introductions/": {
      "filePath": "_private/_route/_internal/introductions/index.route.tsx",
      "parent": "/_private/_route/_internal"
    },
    "/_private/_route/_internal/peers/": {
      "filePath": "_private/_route/_internal/peers/index.route.tsx",
      "parent": "/_private/_route/_internal"
    },
    "/_private/_route/_internal/people/": {
      "filePath": "_private/_route/_internal/people/index.route.tsx",
      "parent": "/_private/_route/_internal"
    },
    "/_private/_route/_internal/performance/": {
      "filePath": "_private/_route/_internal/performance/index.route.tsx",
      "parent": "/_private/_route/_internal"
    },
    "/_private/_route/_internal/pipeline-submissions/": {
      "filePath": "_private/_route/_internal/pipeline-submissions/index.route.tsx",
      "parent": "/_private/_route/_internal"
    },
    "/_private/_route/_internal/search-submissions/": {
      "filePath": "_private/_route/_internal/search-submissions/index.route.tsx",
      "parent": "/_private/_route/_internal"
    },
    "/_private/_route/_internal/searches/": {
      "filePath": "_private/_route/_internal/searches/index.route.tsx",
      "parent": "/_private/_route/_internal"
    },
    "/_private/_route/_internal/tasks/": {
      "filePath": "_private/_route/_internal/tasks/index.route.tsx",
      "parent": "/_private/_route/_internal/tasks"
    },
    "/_private/_route/_internal/tools/": {
      "filePath": "_private/_route/_internal/tools/index.route.tsx",
      "parent": "/_private/_route/_internal"
    },
    "/_private/_route/_internal/trending/": {
      "filePath": "_private/_route/_internal/trending/index.route.tsx",
      "parent": "/_private/_route/_internal/trending"
    },
    "/_private/_route/profile/teams/": {
      "filePath": "_private/_route/profile/teams/index.route.tsx",
      "parent": "/_private/_route/profile"
    },
    "/_private/_route/users/$userId/": {
      "filePath": "_private/_route/users/$userId/index.route.tsx",
      "parent": "/_private/_route/users/$userId"
    },
    "/_private/_route/users/new/": {
      "filePath": "_private/_route/users/new/index.route.tsx",
      "parent": "/_private/_route"
    },
    "/_private/_route/_internal/admin/users/$userId": {
      "filePath": "_private/_route/_internal/admin/users/$userId/route.tsx",
      "parent": "/_private/_route/_internal/admin",
      "children": [
        "/_private/_route/_internal/admin/users/$userId/settings/"
      ]
    },
    "/_private/_route/_internal/candidates/$candidateId/tasks": {
      "filePath": "_private/_route/_internal/candidates/$candidateId/tasks/route.tsx",
      "parent": "/_private/_route/_internal/candidates/$candidateId",
      "children": [
        "/_private/_route/_internal/candidates/$candidateId/tasks/goals/$goalId/"
      ]
    },
    "/_private/_route/_internal/events/$eventId/participants": {
      "filePath": "_private/_route/_internal/events/$eventId/participants/route.tsx",
      "parent": "/_private/_route/_internal/events/$eventId",
      "children": [
        "/_private/_route/_internal/events/$eventId/participants/new/"
      ]
    },
    "/_private/_route/_internal/events/participants/$participantId": {
      "filePath": "_private/_route/_internal/events/participants/$participantId/route.tsx",
      "parent": "/_private/_route/_internal/events",
      "children": [
        "/_private/_route/_internal/events/participants/$participantId/"
      ]
    },
    "/_private/_route/_internal/people/$identityId/_candidate": {
      "filePath": "_private/_route/_internal/people/$identityId/_candidate/route.tsx",
      "parent": "/_private/_route/_internal/people/$identityId",
      "children": [
        "/_private/_route/_internal/people/$identityId/_candidate/tasks",
        "/_private/_route/_internal/people/$identityId/_candidate/about/",
        "/_private/_route/_internal/people/$identityId/_candidate/compare/",
        "/_private/_route/_internal/people/$identityId/_candidate/feedback/",
        "/_private/_route/_internal/people/$identityId/_candidate/performance/",
        "/_private/_route/_internal/people/$identityId/_candidate/profile/",
        "/_private/_route/_internal/people/$identityId/_candidate/recommendations/",
        "/_private/_route/_internal/people/$identityId/_candidate/suggested-pipelines/"
      ]
    },
    "/_private/_route/teams/$teamId/candidates/$candidateId": {
      "filePath": "_private/_route/teams/$teamId/candidates/$candidateId/route.tsx",
      "parent": "/_private/_route/teams/$teamId/candidates",
      "children": [
        "/_private/_route/teams/$teamId/candidates/$candidateId/$tabId",
        "/_private/_route/teams/$teamId/candidates/$candidateId/",
        "/_private/_route/teams/$teamId/candidates/$candidateId/activity/",
        "/_private/_route/teams/$teamId/candidates/$candidateId/pipelines/"
      ]
    },
    "/_private/_route/teams/$teamId/pipelines/new": {
      "filePath": "_private/_route/teams/$teamId/pipelines/new.route.tsx",
      "parent": "/_private/_route/teams/$teamId"
    },
    "/_private/_route/users/$userId/people/$candidateId": {
      "filePath": "_private/_route/users/$userId/people/$candidateId/route.tsx",
      "parent": "/_private/_route/users/$userId/people"
    },
    "/_private/_route/users/$userId/pipelines/new": {
      "filePath": "_private/_route/users/$userId/pipelines/new.route.tsx",
      "parent": "/_private/_route/users/$userId"
    },
    "/_private/_route/teams/$teamId/pipelines/$pipelineId": {
      "filePath": "_private/_route/teams/$teamId/pipelines/$pipelineId/lazy.tsx",
      "parent": "/_private/_route/teams/$teamId",
      "children": [
        "/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal",
        "/_private/_route/teams/$teamId/pipelines/$pipelineId/introductions/$candidateId/"
      ]
    },
    "/_private/_route/_internal/admin/users/": {
      "filePath": "_private/_route/_internal/admin/users/index.route.tsx",
      "parent": "/_private/_route/_internal/admin"
    },
    "/_private/_route/_internal/candidates/$candidateId/": {
      "filePath": "_private/_route/_internal/candidates/$candidateId/index.route.tsx",
      "parent": "/_private/_route/_internal/candidates/$candidateId"
    },
    "/_private/_route/_internal/candidates/new/": {
      "filePath": "_private/_route/_internal/candidates/new/index.route.tsx",
      "parent": "/_private/_route/_internal"
    },
    "/_private/_route/_internal/events/$eventId/": {
      "filePath": "_private/_route/_internal/events/$eventId/index.route.tsx",
      "parent": "/_private/_route/_internal/events/$eventId"
    },
    "/_private/_route/_internal/events/events/": {
      "filePath": "_private/_route/_internal/events/events/index.route.tsx",
      "parent": "/_private/_route/_internal/events"
    },
    "/_private/_route/_internal/events/new/": {
      "filePath": "_private/_route/_internal/events/new/index.route.tsx",
      "parent": "/_private/_route/_internal/events"
    },
    "/_private/_route/_internal/events/participants/": {
      "filePath": "_private/_route/_internal/events/participants/index.route.tsx",
      "parent": "/_private/_route/_internal/events"
    },
    "/_private/_route/_internal/events/settings/": {
      "filePath": "_private/_route/_internal/events/settings/index.route.tsx",
      "parent": "/_private/_route/_internal/events"
    },
    "/_private/_route/_internal/introduction-submissions/$submissionId/": {
      "filePath": "_private/_route/_internal/introduction-submissions/$submissionId/index.route.tsx",
      "parent": "/_private/_route/_internal"
    },
    "/_private/_route/_internal/peers/new/": {
      "filePath": "_private/_route/_internal/peers/new/index.route.tsx",
      "parent": "/_private/_route/_internal"
    },
    "/_private/_route/_internal/people/$identityId/": {
      "filePath": "_private/_route/_internal/people/$identityId/index.route.tsx",
      "parent": "/_private/_route/_internal/people/$identityId"
    },
    "/_private/_route/_internal/pipeline-submissions/$submissionId/": {
      "filePath": "_private/_route/_internal/pipeline-submissions/$submissionId/index.route.tsx",
      "parent": "/_private/_route/_internal"
    },
    "/_private/_route/_internal/tasks/executive-services/": {
      "filePath": "_private/_route/_internal/tasks/executive-services/index.route.tsx",
      "parent": "/_private/_route/_internal/tasks"
    },
    "/_private/_route/_internal/tasks/me/": {
      "filePath": "_private/_route/_internal/tasks/me/index.route.tsx",
      "parent": "/_private/_route/_internal/tasks"
    },
    "/_private/_route/_internal/tools/ai-candidate-discovery/": {
      "filePath": "_private/_route/_internal/tools/ai-candidate-discovery/index.route.tsx",
      "parent": "/_private/_route/_internal"
    },
    "/_private/_route/_internal/tools/email-templates/": {
      "filePath": "_private/_route/_internal/tools/email-templates/index.route.tsx",
      "parent": "/_private/_route/_internal"
    },
    "/_private/_route/_internal/tools/market-searches/": {
      "filePath": "_private/_route/_internal/tools/market-searches/index.route.tsx",
      "parent": "/_private/_route/_internal"
    },
    "/_private/_route/_internal/tools/merge-people/": {
      "filePath": "_private/_route/_internal/tools/merge-people/index.route.tsx",
      "parent": "/_private/_route/_internal"
    },
    "/_private/_route/_internal/tools/move-team/": {
      "filePath": "_private/_route/_internal/tools/move-team/index.route.tsx",
      "parent": "/_private/_route/_internal"
    },
    "/_private/_route/_internal/tools/pathway-activity-defaults/": {
      "filePath": "_private/_route/_internal/tools/pathway-activity-defaults/index.route.tsx",
      "parent": "/_private/_route/_internal"
    },
    "/_private/_route/_internal/trending/$submissionId/": {
      "filePath": "_private/_route/_internal/trending/$submissionId/index.route.tsx",
      "parent": "/_private/_route/_internal/trending"
    },
    "/_private/_route/_internal/trending/campaigns/": {
      "filePath": "_private/_route/_internal/trending/campaigns/index.route.tsx",
      "parent": "/_private/_route/_internal/trending"
    },
    "/_private/_route/_internal/trending/new/": {
      "filePath": "_private/_route/_internal/trending/new/index.route.tsx",
      "parent": "/_private/_route/_internal/trending"
    },
    "/_private/_route/_internal/trending/people/": {
      "filePath": "_private/_route/_internal/trending/people/index.route.tsx",
      "parent": "/_private/_route/_internal/trending"
    },
    "/_private/_route/teams/$teamId/home/": {
      "filePath": "_private/_route/teams/$teamId/home/index.route.tsx",
      "parent": "/_private/_route/teams/$teamId"
    },
    "/_private/_route/teams/$teamId/introductions/": {
      "filePath": "_private/_route/teams/$teamId/introductions/index.route.tsx",
      "parent": "/_private/_route/teams/$teamId"
    },
    "/_private/_route/teams/$teamId/pipelines/": {
      "filePath": "_private/_route/teams/$teamId/pipelines/index.route.tsx",
      "parent": "/_private/_route/teams/$teamId"
    },
    "/_private/_route/teams/$teamId/searches/": {
      "filePath": "_private/_route/teams/$teamId/searches/index.route.tsx",
      "parent": "/_private/_route/teams/$teamId"
    },
    "/_private/_route/teams/$teamId/settings/": {
      "filePath": "_private/_route/teams/$teamId/settings/index.route.tsx",
      "parent": "/_private/_route/teams/$teamId"
    },
    "/_private/_route/users/$userId/events/": {
      "filePath": "_private/_route/users/$userId/events/index.route.tsx",
      "parent": "/_private/_route/users/$userId"
    },
    "/_private/_route/users/$userId/pipelines/": {
      "filePath": "_private/_route/users/$userId/pipelines/index.route.tsx",
      "parent": "/_private/_route/users/$userId"
    },
    "/_private/_route/users/$userId/settings/": {
      "filePath": "_private/_route/users/$userId/settings/index.route.tsx",
      "parent": "/_private/_route/users/$userId"
    },
    "/_private/_route/teams/$teamId/trending/": {
      "filePath": "_private/_route/teams/$teamId/trending/index.tsx",
      "parent": "/_private/_route/teams/$teamId/trending"
    },
    "/_private/_route/users/$userId/trending/": {
      "filePath": "_private/_route/users/$userId/trending/index.tsx",
      "parent": "/_private/_route/users/$userId/trending"
    },
    "/_private/_route/_internal/people/$identityId/_candidate/tasks": {
      "filePath": "_private/_route/_internal/people/$identityId/_candidate/tasks/route.tsx",
      "parent": "/_private/_route/_internal/people/$identityId/_candidate",
      "children": [
        "/_private/_route/_internal/people/$identityId/_candidate/tasks/",
        "/_private/_route/_internal/people/$identityId/_candidate/tasks/goals/$goalId/"
      ]
    },
    "/_private/_route/teams/$teamId/candidates/$candidateId/$tabId": {
      "filePath": "_private/_route/teams/$teamId/candidates/$candidateId/$tabId.route.tsx",
      "parent": "/_private/_route/teams/$teamId/candidates/$candidateId"
    },
    "/_private/_route/teams/$teamId/pipelines/$pipelineId/edit": {
      "filePath": "_private/_route/teams/$teamId/pipelines_/$pipelineId/edit.route.tsx",
      "parent": "/_private/_route/teams/$teamId"
    },
    "/_private/_route/users/$userId/pipelines/$pipelineId/edit": {
      "filePath": "_private/_route/users/$userId/pipelines/$pipelineId/edit.route.tsx",
      "parent": "/_private/_route/users/$userId"
    },
    "/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal": {
      "filePath": "_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/lazy.tsx",
      "parent": "/_private/_route/teams/$teamId/pipelines/$pipelineId",
      "children": [
        "/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/",
        "/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations"
      ]
    },
    "/_private/_route/_internal/admin/users/new/": {
      "filePath": "_private/_route/_internal/admin/users/new/index.route.tsx",
      "parent": "/_private/_route/_internal/admin"
    },
    "/_private/_route/_internal/candidates/$candidateId/about/": {
      "filePath": "_private/_route/_internal/candidates/$candidateId/about/index.route.tsx",
      "parent": "/_private/_route/_internal/candidates/$candidateId"
    },
    "/_private/_route/_internal/candidates/$candidateId/accounts/": {
      "filePath": "_private/_route/_internal/candidates/$candidateId/accounts/index.route.tsx",
      "parent": "/_private/_route/_internal/candidates/$candidateId"
    },
    "/_private/_route/_internal/candidates/$candidateId/compare/": {
      "filePath": "_private/_route/_internal/candidates/$candidateId/compare/index.route.tsx",
      "parent": "/_private/_route/_internal/candidates/$candidateId"
    },
    "/_private/_route/_internal/candidates/$candidateId/feedback/": {
      "filePath": "_private/_route/_internal/candidates/$candidateId/feedback/index.route.tsx",
      "parent": "/_private/_route/_internal/candidates/$candidateId"
    },
    "/_private/_route/_internal/candidates/$candidateId/performance/": {
      "filePath": "_private/_route/_internal/candidates/$candidateId/performance/index.route.tsx",
      "parent": "/_private/_route/_internal/candidates/$candidateId"
    },
    "/_private/_route/_internal/candidates/$candidateId/profile/": {
      "filePath": "_private/_route/_internal/candidates/$candidateId/profile/index.route.tsx",
      "parent": "/_private/_route/_internal/candidates/$candidateId"
    },
    "/_private/_route/_internal/candidates/$candidateId/recommendations/": {
      "filePath": "_private/_route/_internal/candidates/$candidateId/recommendations.index.route.tsx",
      "parent": "/_private/_route/_internal/candidates/$candidateId"
    },
    "/_private/_route/_internal/candidates/$candidateId/suggested-pipelines/": {
      "filePath": "_private/_route/_internal/candidates/$candidateId/suggested-pipelines/index.route.tsx",
      "parent": "/_private/_route/_internal/candidates/$candidateId"
    },
    "/_private/_route/_internal/companies/$companyId/people/": {
      "filePath": "_private/_route/_internal/companies/$companyId/people/index.route.tsx",
      "parent": "/_private/_route/_internal"
    },
    "/_private/_route/_internal/companies/$companyId/settings/": {
      "filePath": "_private/_route/_internal/companies/$companyId/settings/index.route.tsx",
      "parent": "/_private/_route/_internal"
    },
    "/_private/_route/_internal/events/$eventId/details/": {
      "filePath": "_private/_route/_internal/events/$eventId/details/index.route.tsx",
      "parent": "/_private/_route/_internal/events/$eventId"
    },
    "/_private/_route/_internal/events/$eventId/email-settings/": {
      "filePath": "_private/_route/_internal/events/$eventId/email-settings/index.route.tsx",
      "parent": "/_private/_route/_internal/events/$eventId"
    },
    "/_private/_route/_internal/events/$eventId/emails/": {
      "filePath": "_private/_route/_internal/events/$eventId/emails/index.route.tsx",
      "parent": "/_private/_route/_internal/events/$eventId"
    },
    "/_private/_route/_internal/events/participants/$participantId/": {
      "filePath": "_private/_route/_internal/events/participants/$participantId/index.route.tsx",
      "parent": "/_private/_route/_internal/events/participants/$participantId"
    },
    "/_private/_route/_internal/people/$identityId/accounts/": {
      "filePath": "_private/_route/_internal/people/$identityId/accounts/index.route.tsx",
      "parent": "/_private/_route/_internal/people/$identityId"
    },
    "/_private/_route/_internal/people/$identityId/emails/": {
      "filePath": "_private/_route/_internal/people/$identityId/emails/index.route.tsx",
      "parent": "/_private/_route/_internal/people/$identityId"
    },
    "/_private/_route/_internal/trending/$submissionId/edit/": {
      "filePath": "_private/_route/_internal/trending/$submissionId/edit/index.route.tsx",
      "parent": "/_private/_route/_internal/trending"
    },
    "/_private/_route/teams/$teamId/candidates/$candidateId/": {
      "filePath": "_private/_route/teams/$teamId/candidates/$candidateId/index.route.tsx",
      "parent": "/_private/_route/teams/$teamId/candidates/$candidateId"
    },
    "/_private/_route/teams/$teamId/introductions/$candidateId/": {
      "filePath": "_private/_route/teams/$teamId/introductions/$candidateId/index.route.tsx",
      "parent": "/_private/_route/teams/$teamId"
    },
    "/_private/_route/teams/$teamId/searches/$searchId/": {
      "filePath": "_private/_route/teams/$teamId/searches/$searchId/index.route.tsx",
      "parent": "/_private/_route/teams/$teamId"
    },
    "/_private/_route/teams/$teamId/trending/$recommendationId/": {
      "filePath": "_private/_route/teams/$teamId/trending/$recommendationId/index.route.tsx",
      "parent": "/_private/_route/teams/$teamId/trending"
    },
    "/_private/_route/users/$userId/events/$eventId/": {
      "filePath": "_private/_route/users/$userId/events/$eventId/index.route.tsx",
      "parent": "/_private/_route/users/$userId"
    },
    "/_private/_route/users/$userId/pipelines/$pipelineId/": {
      "filePath": "_private/_route/users/$userId/pipelines/$pipelineId/index.route.tsx",
      "parent": "/_private/_route/users/$userId"
    },
    "/_private/_route/users/$userId/trending/$recommendationId/": {
      "filePath": "_private/_route/users/$userId/trending/$recommendationId/index.route.tsx",
      "parent": "/_private/_route/users/$userId/trending"
    },
    "/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/": {
      "filePath": "_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/index/route.tsx",
      "parent": "/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal"
    },
    "/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations": {
      "filePath": "_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations/route.tsx",
      "parent": "/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal",
      "children": [
        "/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations/",
        "/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations/$recommendationId/"
      ]
    },
    "/_private/_route/teams/$teamId/pipelines/$pipelineId/recommendations/new": {
      "filePath": "_private/_route/teams/$teamId/pipelines/$pipelineId_/recommendations/new/route.tsx",
      "parent": "/_private/_route/teams/$teamId"
    },
    "/_private/_route/users/$userId/pipelines/$pipelineId/recommendations/new": {
      "filePath": "_private/_route/users/$userId/pipelines/$pipelineId_/recommendations/new/route.tsx",
      "parent": "/_private/_route/users/$userId"
    },
    "/_private/_route/_internal/admin/users/$userId/settings/": {
      "filePath": "_private/_route/_internal/admin/users/$userId/settings/index.route.tsx",
      "parent": "/_private/_route/_internal/admin/users/$userId"
    },
    "/_private/_route/_internal/events/$eventId/participants/new/": {
      "filePath": "_private/_route/_internal/events/$eventId/participants/new/index.route.tsx",
      "parent": "/_private/_route/_internal/events/$eventId/participants"
    },
    "/_private/_route/_internal/people/$identityId/_candidate/about/": {
      "filePath": "_private/_route/_internal/people/$identityId/_candidate/about/index.route.tsx",
      "parent": "/_private/_route/_internal/people/$identityId/_candidate"
    },
    "/_private/_route/_internal/people/$identityId/_candidate/compare/": {
      "filePath": "_private/_route/_internal/people/$identityId/_candidate/compare/index.route.tsx",
      "parent": "/_private/_route/_internal/people/$identityId/_candidate"
    },
    "/_private/_route/_internal/people/$identityId/_candidate/feedback/": {
      "filePath": "_private/_route/_internal/people/$identityId/_candidate/feedback/index.route.tsx",
      "parent": "/_private/_route/_internal/people/$identityId/_candidate"
    },
    "/_private/_route/_internal/people/$identityId/_candidate/performance/": {
      "filePath": "_private/_route/_internal/people/$identityId/_candidate/performance/index.route.tsx",
      "parent": "/_private/_route/_internal/people/$identityId/_candidate"
    },
    "/_private/_route/_internal/people/$identityId/_candidate/profile/": {
      "filePath": "_private/_route/_internal/people/$identityId/_candidate/profile/index.route.tsx",
      "parent": "/_private/_route/_internal/people/$identityId/_candidate"
    },
    "/_private/_route/_internal/people/$identityId/_candidate/recommendations/": {
      "filePath": "_private/_route/_internal/people/$identityId/_candidate/recommendations.index.route.tsx",
      "parent": "/_private/_route/_internal/people/$identityId/_candidate"
    },
    "/_private/_route/_internal/people/$identityId/_candidate/suggested-pipelines/": {
      "filePath": "_private/_route/_internal/people/$identityId/_candidate/suggested-pipelines/index.route.tsx",
      "parent": "/_private/_route/_internal/people/$identityId/_candidate"
    },
    "/_private/_route/teams/$teamId/candidates/$candidateId/activity/": {
      "filePath": "_private/_route/teams/$teamId/candidates/$candidateId/activity/index.route.tsx",
      "parent": "/_private/_route/teams/$teamId/candidates/$candidateId"
    },
    "/_private/_route/teams/$teamId/candidates/$candidateId/pipelines/": {
      "filePath": "_private/_route/teams/$teamId/candidates/$candidateId/pipelines/index.route.tsx",
      "parent": "/_private/_route/teams/$teamId/candidates/$candidateId"
    },
    "/_private/_route/_internal/people/$identityId/_candidate/tasks/": {
      "filePath": "_private/_route/_internal/people/$identityId/_candidate/tasks/index.lazy.tsx",
      "parent": "/_private/_route/_internal/people/$identityId/_candidate/tasks"
    },
    "/_private/_route/_internal/candidates/$candidateId/tasks/goals/$goalId/": {
      "filePath": "_private/_route/_internal/candidates/$candidateId/tasks/goals/$goalId/index.route.tsx",
      "parent": "/_private/_route/_internal/candidates/$candidateId/tasks"
    },
    "/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations/": {
      "filePath": "_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations/index.route.tsx",
      "parent": "/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations"
    },
    "/_private/_route/teams/$teamId/pipelines/$pipelineId/introductions/$candidateId/": {
      "filePath": "_private/_route/teams/$teamId/pipelines/$pipelineId/introductions.$candidateId.index.route.tsx",
      "parent": "/_private/_route/teams/$teamId/pipelines/$pipelineId"
    },
    "/_private/_route/teams/$teamId/pipelines/$pipelineId/submissions/$submissionId/": {
      "filePath": "_private/_route/teams/$teamId/pipelines/$pipelineId_/submissions.$submissionId.index.route.tsx",
      "parent": "/_private/_route/teams/$teamId"
    },
    "/_private/_route/teams/$teamId/searches/$searchId/candidates/$candidateId/": {
      "filePath": "_private/_route/teams/$teamId/searches/$searchId/candidates/$candidateId/index.route.tsx",
      "parent": "/_private/_route/teams/$teamId"
    },
    "/_private/_route/users/$userId/pipelines/$pipelineId/recommendations/$recommendationId/": {
      "filePath": "_private/_route/users/$userId/pipelines/$pipelineId/recommendations.$recommendationId.index.route.tsx",
      "parent": "/_private/_route/users/$userId"
    },
    "/_private/_route/_internal/people/$identityId/_candidate/tasks/goals/$goalId/": {
      "filePath": "_private/_route/_internal/people/$identityId/_candidate/tasks/goals/$goalId/index.route.tsx",
      "parent": "/_private/_route/_internal/people/$identityId/_candidate/tasks"
    },
    "/_private/_route/_internal/teams/$teamId/searches/$searchId/submissions/$submissionId/": {
      "filePath": "_private/_route/_internal/teams/$teamId/searches/$searchId/submissions/$submissionId/index.route.tsx",
      "parent": "/_private/_route/_internal"
    },
    "/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations/$recommendationId/": {
      "filePath": "_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations/$recommendationId/index.route.tsx",
      "parent": "/_private/_route/teams/$teamId/pipelines/$pipelineId/_internal/recommendations"
    }
  }
}
ROUTE_MANIFEST_END */
